/**
 * featureBindings.js — AI, segmentation, clinical tools, TAVI, reports, comparison,
 * GPU compute, fusion, endoscopy, measurements, voice control, etc.
 * Extracted from uiManager.js (декомпозиция God Object)
 */

import { getRenderingEngine, getViewportIds, setWindowLevel, set3DPreset, enableMPRSync, applyRenderPreset, startCine, stopCine, loadStack, ensureCinematicRenderer , применитьМРПеренос } from '../core/viewport.js'; // [10.19.30] setOverlayOpacity/Colormap и addVolumeOverlay ушли вместе с кустом кнопок-призраков
import { getCinematicRenderer } from '../core/viewportState.js'; // [7.0.50/51] cine + overlay движок
// [10.19.16] Один путь включения кинематографического рендеринга для ВСЕХ кнопок.
import { включитьКино, выключитьКино, переключитьКино } from './cinematicControl.js';
import { getOrtBackend } from '../rendering/cinematic10/ortLoader.js'; // [10.19.24] фактический движок ONNX — для честной подписи ai-backend
import { setActiveTool, getActiveTool, clearAnnotations, getAnnotations, exportAnnotations, removeAnnotation, setBrushSize, setActiveSegment, getActiveSegmentationId, setSegmentationOpacity, getSegmentationData } from '../tools/toolManager.js'; // [7.0.49] exportAnnotations — был ReferenceError на btn-meas-json; [11.0.2] removeAnnotation — крестик в таблице измерений; четыре последних — провода к движку сегментации
import { getSeriesImageIds, loadDICOMFiles } from '../loaders/loaderManager.js'; // [7.0.49] prior-серия; getAllSeries ушёл с кустом призраков [10.19.30]
import { showToast, formatPatientName, downloadBlob, escapeHtml } from '../utils/helpers.js';
import { screenshotViewport } from '../core/viewport.js';
import { emit, on as on_, EVENTS } from '../core/eventBus.js';
import { registerAPIs } from '../core/viewerAPI.js';
import { getGPUInfo } from '../core/gpuDetector.js';
import { setVolumeClipping, setClipAxisEnabled, startAutoSpin, stopAutoSpin, isAutoSpinOn, setAutoSpinTurntable } from '../core/viewportEffects.js';
import { stopAutoRotate } from '../core/viewportCamera.js'; // [10.19.31] мост: выключатель глушит кнопочное вращение (Гориз./Верт.) // [10.19.30] выключатели осей и автовращение — настоящие
import { knownVolumeIds, onRegistryChange } from '../core/volumeRegistry.js'; // [10.19.30] список объёмов для DSA
import { _updateUndoRedoButtons, bindAnnotationEvents, bindUndoRedoKeys, undoAnnotation, redoAnnotation } from './toolBindings.js';
import { bindTFEditor } from './sidebarBindings.js';
import { changeLayout } from './layoutManager.js';
import { updateWLOverlay } from './seriesPanel.js';
import { openPrintWindow } from './printUtil.js'; // [11.1.16] «Печать» выводит бланк отчёта, а не страницу приложения
import { открытьПечатное, отметитьЭкспорт } from './exportModule.js';
import { скачатьDocxОтчёт, собратьDocxБайты } from '../core/docxReport.js';
import { прочитатьБланк, записатьБланк, названиеОтделения, ОТДЕЛЕНИЕ_ПО_УМОЛЧАНИЮ, собратьШапку, разделВключён, шрифтыБланка, логотипБланка, поляБланка, НАБОРЫ_РАЗДЕЛОВ } from '../core/reportBlank.js'; // [11.1.30] разделы, шрифты, логотип
import { прочитатьЗаключения, сохранитьЗаключение, загрузитьЗаключение, удалитьЗаключение, ключЗаключения, собратьФайлЗаключения, разобратьФайлЗаключения, слитьЗаключения } from '../core/reportDrafts.js'; // [11.1.31] заключения в динамике // [11.1.20] шапка учреждения и автосбор из тегов
import { getDICOMTags } from '../loaders/loaderManager.js';
import { гпуСупВVtk } from '../compute/meshConvert.js';   // [11.1.22] сведение сеток: GPU-суп → общий формат
import { положитьСетку } from './toolsBindings.js';
import { изолироватьОрган, вернутьТело, stlОргана, томМаски, записатьМаску, подсчётВокселей, объёмМл, запомнитьПравкуМаски, отменитьПравкуМаски } from '../core/organView.js'; // [11.1.24] мост маска→3D // [11.1.38] морфология маски
import { залитьКонтуры, интерполироватьСрезы } from '../core/maskMorph.js';
import { прочитатьМаску, сеткиСовпадают, этоGzip } from '../core/niftiRead.js';   // [11.1.50] мост: чужая маска → наш сегмент       // [11.1.38] заливка контуров и достройка между срезами
import { получитьПоследнийVRTПресет } from './sidebarBindings.js';               // [11.1.24] чем красить тело после возврата        // [11.1.22] построенное подхватывает ряд обработки // [11.1.20] теги открытого исследования для автозаполнения // [11.1.19] редактируемый бланк Word — кириллица гарантирована самим форматом // [11.1.18] в Electron окна запрещены — PDF идёт родной дверью printToPDF
import { log } from '../utils/logger.js';

const $ = (id) => document.getElementById(id);
const $$ = (sel) => document.querySelectorAll(sel);
let _cinematicHandle = null;
// [7.0.49] Были не объявлены → indexedDB.open(MEAS_DB_NAME, …) кидал ReferenceError,
// ломая сохранение измерения и график динамики.
const MEAS_DB_NAME = 'mikhmel-measurements';
const MEAS_DB_VERSION = 1;
let _taviMeasureMode = false;
let _taviPoints = [];

// [FIX-LEAK] AbortController — один signal.abort() убирает все listener'ы
let _abortController = null;
function _getSignal() {
  if (!_abortController) _abortController = new AbortController();
  return _abortController.signal;
}
const on = (id, evt, fn) => { const el = $(id); if (el) el.addEventListener(evt, fn, { signal: _getSignal() }); };

/**
 * Окно результата расчёта. [10.19.30] Вынесено из bindGPUCompute на уровень
 * модуля: тем же окном пользуется DSA-вычитание — заводить второе, чуть иное,
 * значило бы разводить один показ по двум местам.
 */
const _окноРезультата = (заголовок) => {
  const фон = document.createElement('div');
  фон.style.cssText = 'position:fixed;inset:0;z-index:60000;background:rgba(5,8,14,0.72);display:flex;align-items:center;justify-content:center;padding:14px;overflow:auto;';
  const к = document.createElement('div');
  к.style.cssText = 'max-width:720px;width:100%;max-height:92vh;overflow:auto;background:#0f1420;border:1px solid #2a3546;border-radius:14px;padding:16px;color:#dbe6f5;font-size:13px;line-height:1.5;';
  к.innerHTML = `<div style="font-size:15px;font-weight:700;margin-bottom:10px;">${заголовок}</div>`;
  фон.appendChild(к);
  фон.addEventListener('click', (e) => { if (e.target === фон) фон.remove(); });
  const закр = document.createElement('button');
  закр.textContent = 'Закрыть';
  закр.style.cssText = 'margin-top:12px;width:100%;padding:10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;';
  закр.addEventListener('click', () => фон.remove());
  document.body.appendChild(фон);
  return { тело: к, закрыть: закр, фон };
};

/**
 * Взять выключатель СЕБЕ: клон узла снимает общий перещёлкиватель класса из
 * sidebarBindings, и состоянием управляет только этот обработчик. [10.19.30]
 * Тот же приём, что _rebind в proFeaturesBindings: у выключателя с делом не
 * должно быть второго хозяина, который щёлкает классом вслепую.
 * handler получает новое состояние и возвращает false, чтобы ОТКАЗАТЬ во
 * включении (например, крутить нечего) — класс тогда не меняется.
 */
function _ownToggle(id, handler) {
  const el = $(id);
  if (!el) return null;
  const св = el.cloneNode(true);
  el.parentNode.replaceChild(св, el);
  св.addEventListener('click', () => {
    const было = св.classList.contains('on');
    const хочет = !было;
    const ответ = handler(хочет, св);
    if (ответ === false) return; // отказ: состояние не меняем
    св.classList.toggle('on', хочет);
    св.setAttribute('aria-checked', String(хочет));
  }, { signal: _getSignal() });
  return св;
}
const onAll = (sel, evt, fn) => $$(sel).forEach(el => el.addEventListener(evt, fn, { signal: _getSignal() }));

/**
 * Cleanup — убирает все listener'ы, установленные через on()/onAll()
 */
export function destroyFeatureBindings() {
  if (_abortController) { _abortController.abort(); _abortController = null; }
}

// ── Lazy-loaded modules ──
let _aiModule = null;
async function _ai() { return _aiModule || (_aiModule = await import('../ai/aiModule.js')); }
const runDetection = (...a) => _ai().then(m => m.runDetection(...a));
const runClassification = (...a) => _ai().then(m => m.runClassification(...a));
const runSegmentation = (...a) => _ai().then(m => m.runSegmentation(...a)); // [7.0.49] был ReferenceError в ONNX-ветке сегментации
const loadModel = (...a) => _ai().then(m => m.loadModel(...a));
const isModelAvailable = (...a) => _aiModule ? _aiModule.isModelAvailable(...a) : false;
const hasAlgorithmicFallback = (...a) => _aiModule ? _aiModule.hasAlgorithmicFallback(...a) : true;
const segmentCardiacChambers = (...a) => _ai().then(m => m.segmentCardiacChambers(...a));
const estimateEF = (...a) => _ai().then(m => m.estimateEF(...a));
const segmentOrgansByHU = (...a) => _ai().then(m => m.segmentOrgansByHU(...a));
const segmentBrainByHU = (...a) => _ai().then(m => m.segmentBrainByHU(...a));
const autoContourByThreshold = (...a) => _ai().then(m => m.autoContourByThreshold(...a));
const detectLungNodules = (...a) => _ai().then(m => m.detectLungNodules(...a));
const classifyStroke = (...a) => _ai().then(m => m.classifyStroke(...a));

let _gpuModule = null;
async function _gpu() { return _gpuModule || (_gpuModule = await import('../compute/gpuCompute.js')); }

let _dataModule = null;
async function _data() { return _dataModule || (_dataModule = await import('../managers/DatasetManager.js')); }

let _roiWlActive = false;
let _voiceRecognition = null;

let _ctx = null;

/**
 * @param {Object} ctx
 * @param {function():string} ctx.getCurrentViewportId
 * @param {function():string} ctx.getCurrentVolumeId
 * @param {function():string} ctx.getCurrentSeries
 * @param {function():string[]} ctx.getCurrentImageIds
 * @param {function():Object} ctx.getVolumeScalarData
 * @param {function():Array} ctx.getAllSeries
 * @param {function(string)} ctx.openModal
 * @param {function(string)} ctx.closeModal
 * @param {Object} ctx.VRT_PRESET_MAP
 * @param {function():Object} ctx.getCinematicHandle - returns _cinematicHandle
 * @param {function(Object)} ctx.setCinematicHandle
 */
export function initFeatureBindings(ctx) {
  _ctx = ctx;
  bindSegmentation();
  bindAI();
  bindCinematic();
  bindFusion4D();
  bindGPUCompute();
  bindEndoscopy();
  bindMeasurements();
  bindReports();
  bindComparison();
  bindMultiMonitor();
  bindSynchronizer();
  bindClinicalTools();
  bindSpecialModes();
  bindClinicalExtras();
}

function bindSegmentation() {
  // [11.0.2] ТРИ ПРОВОДА К ДВИЖКУ СЕГМЕНТАЦИИ.
  //
  // Пульт в правом сайдбаре был построен целиком, а провода к нему не
  // протянуты. Движок при этом собран и работает: кисть (BrushTool, клавиша D)
  // и пороговая кисть живут в тулбаре, сама сегментация создаётся сама при
  // первом включении кисти (toolManager.#tryCreateSegmentation), а функции
  // `setBrushSize`, `setActiveSegment`, `getSegmentationData` экспортированы
  // из toolManager. НИ ОДНА из них не вызывалась нигде в проекте — проверено
  // поиском. Пульт построили, провода забыли.
  //
  // Провод 1 — размер кисти. Ползунок менял только цифру рядом с собой.
  const кисть = $('brush-size');
  if (кисть) {
    кисть.addEventListener('change', () => {
      const r = Number(кисть.value) || 10;
      try {
        setBrushSize(r);
        showToast(`Размер кисти: ${r}`, 'info', 900);
      } catch (e) { log.warn('[Сегментация] размер кисти:', e.message); }
    }, { signal: _getSignal() });
  }

  // Провод 2 — прозрачность маски поверх снимка.
  const прозрачность = $('seg-opacity');
  if (прозрачность) {
    прозрачность.addEventListener('change', () => {
      const доля = (Number(прозрачность.value) || 60) / 100;
      const вышло = setSegmentationOpacity(доля);
      if (!вышло) {
        // Молчать нельзя: ползунок двинулся, на экране ничего — ровно та
        // беда, из-за которой поломку не замечали годами.
        showToast('Маски пока нет: возьмите кисть и проведите по снимку — прозрачность настроится на неё', 'info', 4000);
      }
    }, { signal: _getSignal() });
  }

  // Провод 3 — выбор активного сегмента. Щелчок по строке красил класс
  // `active` и на этом заканчивался: кисть продолжала рисовать первым
  // сегментом, каким бы ни был выбран в списке.
  const список = $('segment-list');
  if (список) {
    // [11.1.21] Номер сегмента теперь ЖИВЁТ В СТРОКЕ (data-seg-index), а не
    // вычисляется по позиции. Прежний indexOf+1 лгал после удаления: убрали
    // «Сегмент 2» — строка «Сегмент 3» становилась второй и включала СЕГМЕНТ
    // 2 движка (аудит §2.2). Заодно у active-класса был ТРИ хозяина
    // (делегация + onAll по статичным + per-row у добавленных) — остался
    // один делегат: он и класс ведёт, и движок переключает, и удаляет.
    список.addEventListener('click', (e) => {
      const строка = e.target.closest('.seg-row');
      if (!строка) return;
      if (e.target.closest('.ann-del-btn')) {
        const н = строка.dataset.segIndex || '?';
        if (!confirm(`Убрать «Сегмент ${н}» из списка? Уже нарисованные мазки этого сегмента останутся на снимке под своим цветом.`)) return;
        строка.remove();
        return;
      }
      $$('.seg-row').forEach((r) => r.classList.remove('active'));
      строка.classList.add('active');
      const индекс = Number(строка.dataset.segIndex) || 1;
      const segId = getActiveSegmentationId();
      if (!segId) { showToast('Сегментации ещё нет: возьмите кисть и проведите по снимку', 'info', 3500); return; }
      try {
        setActiveSegment(segId, индекс);
        showToast(`Рисуем сегментом ${индекс}`, 'info', 1000);
      } catch (err) { log.warn('[Сегментация] активный сегмент:', err.message); }
    }, { signal: _getSignal() });
  }

  // [11.1.24] «Только орган в 3D» — мост от маски к объёмному виду
  // (проект по слову владельца). Активный сегмент берётся из строки списка
  // (data-seg-index, 11.1.21), цвет — из её кружка.
  const _активныйСегмент = () => {
    const строка = document.querySelector('#segment-list .seg-row.active') || document.querySelector('#segment-list .seg-row');
    return {
      индекс: Number(строка?.dataset.segIndex) || 1,
      цвет: строка?.querySelector('.seg-color')?.style.background || '#ef4444',
      имя: строка?.querySelector('.seg-label')?.textContent || 'Сегмент',
    };
  };

  on('btn-seg-organ-3d', 'click', async () => {
    const с = _активныйСегмент();
    showToast(`Прячу тело, оставляю «${с.имя}»…`, 'info', 1500);
    const р = await изолироватьОрган({ индекс: с.индекс, цвет: с.цвет });
    if (!р.ок) { showToast(р.причина, 'warning', 4500); return; }
    const w = _окноРезультата(`Только орган · ${с.имя}`);
    w.тело.insertAdjacentHTML('beforeend',
      `<div>Объём: <b>${р.мл.toFixed(1)} мл</b> · вокселей ${р.вокселей.toLocaleString('ru-RU')}</div>`
      + '<div style="margin-top:6px;color:#8fa3c0;">Объём посчитан по маске — он ровно настолько точен, насколько аккуратно обведён орган. Не для диагностики.</div>');
    const назад = document.createElement('button');
    назад.textContent = 'Вернуть тело';
    назад.style.cssText = 'margin-top:10px;width:100%;padding:10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;cursor:pointer;';
    назад.addEventListener('click', async () => {
      const в = await вернутьТело();
      if (!в.ок) { showToast(в.причина, 'warning', 3500); return; }
      // Тело вернулось «сырым» — пере-применяем последний выбранный пресет,
      // чтобы врач увидел ту же картинку, что была до изоляции.
      const посл = получитьПоследнийVRTПресет();
      if (посл) applyRenderPreset(посл.cs3d, { ww: посл.ww, wc: посл.wc });
      showToast('Тело возвращено', 'success', 1500);
      w.фон?.remove?.();   // окно результата закрывается вместе с возвратом тела
    });
    const стлКн = document.createElement('button');
    стлКн.textContent = 'Сохранить STL органа (мм)';
    стлКн.style.cssText = назад.style.cssText;
    стлКн.addEventListener('click', async () => {
      showToast('Строю поверхность органа по маске…', 'info', 2500);
      const r = await stlОргана({ индекс: с.индекс });
      if (!r.ок) { showToast(r.причина, 'warning', 4500); return; }
      отметитьЭкспорт('STL органа', r.имя, (r.sizeKb || 0) / 1024);
      showToast(`STL органа сохранён: ${r.треугольников.toLocaleString('ru-RU')} треуг., в миллиметрах`, 'success', 3000);
    });
    w.тело.appendChild(назад);
    w.тело.appendChild(стлКн);
    w.тело.appendChild(w.закрыть);
  });

  // [11.1.38] МОРФОЛОГИЯ МАСКИ — заливка контуров и достройка между срезами.
  // Повод: владелец обвёл селезёнку контуром в трёх проекциях и получил
  // 2,0 мл вместо ~840 см³. Программа считала верно — закрашена была
  // скорлупка. Обе операции работают на КОПИИ массива маски (Cornerstone 5
  // отдаёт копию) и кладут её обратно через organView.записатьМаску.
  const _осьПоПроекции = () => {
    // Заливать имеет смысл вдоль той оси, поперёк которой врач рисовал:
    // в аксиальном окне контур замкнут в плоскости XY (ось Z = 2).
    // Сагиттальные и корональные обводки замкнуты по своим осям — их
    // ось выбирается тем же списком; по умолчанию аксиальная.
    const akt = String(window._mikhmelПоследнееОкно || '').toLowerCase();
    if (akt.includes('sagittal')) return 0;
    if (akt.includes('coronal')) return 1;
    return 2;
  };
  const _морфология = async (какая) => {
    const с = _активныйСегмент();
    const м = томМаски();
    if (м.ошибка) { showToast(м.ошибка, 'warning', 4500); return; }
    const пиксели = м.пиксели;
    const dims = Array.from(м.dims || []);
    const spacing = Array.from(м.spacing || [1, 1, 1]);
    const было = подсчётВокселей(пиксели, с.индекс);
    if (!было) { showToast(`Сегмент «${с.имя}» пуст — сначала обведите орган кистью`, 'warning', 4500); return; }
    const ось = _осьПоПроекции();
    showToast(какая === 'заливка' ? 'Заливаю контуры…' : 'Достраиваю срезы между обводками…', 'info', 1500);
    let отчёт;
    try {
      отчёт = какая === 'заливка'
        ? залитьКонтуры(пиксели, dims, с.индекс, { ось })
        : интерполироватьСрезы(пиксели, dims, с.индекс, { ось });
    } catch (e) { showToast('Не вышло: ' + e.message, 'error', 4000); return; }
    // [11.1.40] Дельта для отмены запоминается ДО записи: «Вернуть маску»
    // откатывает ровно эту операцию, не трогая ручные мазки.
    запомнитьПравкуМаски(отчёт.изменённые || [], null,
      какая === 'заливка' ? 'заливка контуров' : 'достройка между срезами', отчёт.прежние || null);
    const зап = записатьМаску(пиксели);
    if (!зап.ок) { showToast(зап.причина, 'warning', 4500); return; }
    const стало = подсчётВокселей(пиксели, с.индекс);
    // [11.1.38.1] МОЙ ПРОМАХ, пойманный владельцем на живом: объёмМл имеет
    // подпись (данные, ИНДЕКС, spacing), а я звал её как (число, spacing) —
    // индексом уезжало количество вокселей, spacing уходил в никуда, и врач
    // видел «0.0 мл» при 14 371 закрашенном вокселе. Считаем по массиву.
    const мл = объёмМл(пиксели, с.индекс, spacing);
    const строки = [`Было вокселей: ${было.toLocaleString('ru-RU')} → стало ${стало.toLocaleString('ru-RU')}`,
      `Объём сегмента «${с.имя}»: <b>${мл.toFixed(1)} мл</b>`];
    if (какая === 'заливка') {
      строки.push(`Залито срезов: ${отчёт.срезов}`);
      if (отчёт.протекло.length) {
        строки.push(`<span style="color:#ffb4b4;">Не залито срезов: ${отчёт.протекло.length} — контур на них РАЗОМКНУТ `
          + `(номера: ${отчёт.протекло.slice(0, 12).join(', ')}${отчёт.протекло.length > 12 ? '…' : ''}). `
          + 'Замкните кольцо кистью и повторите — заливка через дыру вытекла бы на весь снимок.</span>');
      }
    } else {
      строки.push(`Ваших обводок: ${отчёт.срезов} · достроено промежутков: ${отчёт.пары}`);
      if (отчёт.пропущено.length) {
        строки.push(`<span style="color:#ffb4b4;">Пропущены слишком большие разрывы между срезами `
          + `${отчёт.пропущено.join(', ')} — это уже не интерполяция, а выдумывание органа. Обведите там ещё срез.</span>`);
      }
      строки.push('<span style="color:#8fa3c0;">Достроенное — геометрическая догадка между вашими обводками, не диагностическая правда. На резких изменениях формы обводите чаще.</span>');
    }
    const w = _окноРезультата(какая === 'заливка' ? 'Заливка контуров' : 'Достройка между срезами');
    w.тело.insertAdjacentHTML('beforeend', строки.map((т) => `<div style="margin-top:6px;">${т}</div>`).join(''));
    w.тело.appendChild(w.закрыть);
    showToast(`${какая === 'заливка' ? 'Залито' : 'Достроено'}: объём ${мл.toFixed(1)} мл`, 'success', 3000);
  };
  on('btn-seg-mask-undo', 'click', () => {
    const р = отменитьПравкуМаски();
    if (!р.ок) { showToast(р.причина, 'warning', 4000); return; }
    showToast(`Откатано: ${р.что} — ${р.вокселей.toLocaleString('ru-RU')} вокселей вернулись как было`, 'success', 4000);
  });
  on('btn-seg-fill', 'click', () => _морфология('заливка'));
  on('btn-seg-interp', 'click', () => _морфология('интерполяция'));

  on('btn-seg-organ-stl', 'click', async () => {
    const с = _активныйСегмент();
    showToast(`Строю поверхность «${с.имя}» по маске…`, 'info', 2500);
    const r = await stlОргана({ индекс: с.индекс });
    if (!r.ок) { showToast(r.причина, 'warning', 4500); return; }
    отметитьЭкспорт('STL органа', r.имя, (r.sizeKb || 0) / 1024);
    showToast(`STL органа сохранён: ${r.треугольников.toLocaleString('ru-RU')} треуг., в миллиметрах`, 'success', 3000);
  });

  // Экспорт маски в NIfTI и очистка — двум кнопкам, у которых раньше не было
  // даже id, дана работа. Обе идут через уже существующие модули: маска
  // лежит в кэше томов Cornerstone, писатель NIfTI — в io/niftiModule.
  // [11.1.50] ИМПОРТ МАСКИ ИЗ .nii — мост к чужой автосегментации.
  on('btn-seg-import-nifti', 'click', () => {
    const поле = $('seg-import-file');
    if (!поле) { showToast('Поле выбора файла не найдено', 'error', 3000); return; }
    поле.value = '';        // чтобы повторный выбор ТОГО ЖЕ файла дал событие
    поле.click();
  });
  on('seg-import-file', 'change', async (e) => {
    const файл = e.target.files?.[0];
    if (!файл) return;
    const с = _активныйСегмент();
    try {
      showToast(`Читаю ${файл.name}…`, 'info', 2000);
      let buffer = await файл.arrayBuffer();
      if (этоGzip(buffer)) {
        // .nii.gz распаковываем средствами браузера: своей библиотеки не
        // заводим ради одного формата. DecompressionStream есть во всех
        // современных браузерах; если нет — честный отказ, а не тишина.
        if (typeof DecompressionStream !== 'function') {
          showToast('Этот браузер не умеет распаковывать .nii.gz — сохраните из Slicer как .nii', 'warning', 6000);
          return;
        }
        const поток = new Blob([buffer]).stream().pipeThrough(new DecompressionStream('gzip'));
        buffer = await new Response(поток).arrayBuffer();
      }
      const м = томМаски();
      if (м.ошибка) { showToast(м.ошибка + ' Возьмите кисть и мазните один раз — холст создастся.', 'warning', 6000); return; }
      const р = прочитатьМаску(buffer, с.индекс);
      if (!р.ок) { showToast(р.причина, 'error', 7000); return; }
      if (р.пусто) { showToast('В файле нет ни одного размеченного вокселя', 'warning', 4500); return; }
      const сверка = сеткиСовпадают(р.dims, р.spacing, м.dims, м.spacing);
      if (!сверка.ок) { showToast(сверка.причина, 'error', 9000); return; }
      if (р.пиксели.length !== м.пиксели.length) {
        showToast('Размер файла не сошёлся с маской исследования', 'error', 6000); return;
      }
      // Дельта для отмены — как у заливки: «Вернуть маску» откатит импорт.
      const изменённые = []; const прежние = [];
      for (let i = 0; i < р.пиксели.length; i++) {
        if (р.пиксели[i] === с.индекс && м.пиксели[i] !== с.индекс) { изменённые.push(i); прежние.push(м.пиксели[i]); }
      }
      запомнитьПравкуМаски(изменённые, null, `импорт «${файл.name}»`, прежние);
      for (const i of изменённые) м.пиксели[i] = с.индекс;
      const зап = записатьМаску(м.пиксели);
      if (!зап.ок) { showToast(зап.причина, 'error', 6000); return; }
      const мл = объёмМл(м.пиксели, с.индекс, м.spacing);
      const w = _окноРезультата('Импорт маски');
      w.тело.insertAdjacentHTML('beforeend',
        [`Файл: <b>${файл.name}</b> · тип ${р.тип} · сетка ${р.dims.join('×')}`,
         `Размечено в файле: ${р.ненулевых.toLocaleString('ru-RU')} вокселей`,
         `Добавлено в сегмент «${с.имя}»: ${изменённые.length.toLocaleString('ru-RU')}`,
         `Объём сегмента: <b>${мл.toFixed(1)} мл</b>`,
         сверка.тревога ? `<span style="color:#ffb4b4;">${сверка.тревога}</span>` : '',
         '<span style="color:#8fa3c0;">Не то загрузилось — «Вернуть маску» в этой же панели.</span>',
        ].filter(Boolean).map((т) => `<div style="margin-top:6px;">${т}</div>`).join(''));
      w.тело.appendChild(w.закрыть);
      showToast(`Маска загружена: ${мл.toFixed(1)} мл`, 'success', 3500);
    } catch (err) {
      showToast('Импорт не вышел: ' + err.message, 'error', 6000);
    }
  });

  on('btn-seg-export-nifti', 'click', async () => {
    const segId = getActiveSegmentationId();
    if (!segId) { showToast('Сегментации ещё нет: возьмите кисть и проведите по снимку', 'info', 3500); return; }
    try {
      // [11.1.45] ВТОРАЯ ДОРОГА К МАСКЕ ПОХОРОНЕНА: своя копия старого поиска
      // (Labelmap.volumeId пустует в Cornerstone 5) — NIfTI говорил «маска не
      // найдена», когда STL уже работал. Хозяин один — томМаски().
      const м = томМаски();
      if (м.ошибка) { showToast(м.ошибка, 'warning', 3500); return; }
      const пиксели = м.пиксели;
      if (!пиксели?.length) { showToast('Маска пуста: рисовать ещё нечего', 'info', 3000); return; }
      const { exportToNifti } = await import('../io/niftiModule.js');
      exportToNifti(пиксели, м.dims, м.spacing, `segmentation_${Date.now()}.nii`);
      showToast('Маска сохранена файлом .nii', 'success', 2500);
    } catch (e) {
      log.warn('[Сегментация] экспорт NIfTI:', e.message);
      showToast('Экспорт маски не удался: ' + e.message, 'error', 4000);
    }
  });

  on('btn-seg-clear', 'click', () => {
    const segId = getActiveSegmentationId();
    if (!segId) { showToast('Стирать нечего: сегментации ещё нет', 'info', 3000); return; }
    try {
      const данные = getSegmentationData(segId);
      const volumeId = данные?.representationData?.Labelmap?.volumeId;
      const том = volumeId ? window.cornerstone?.cache?.getVolume?.(volumeId) : null;
      const пиксели = том?.voxelManager?.getCompleteScalarDataArray?.() || том?.getScalarData?.();
      if (!пиксели?.length) { showToast('Маска пуста — стирать нечего', 'info', 2500); return; }
      пиксели.fill(0);
      том.voxelManager?.setCompleteScalarDataArray?.(пиксели);
      window.cornerstoneTools?.segmentation?.triggerSegmentationEvents?.triggerSegmentationDataModified?.(segId);
      showToast('Маска сегментации стёрта', 'success', 2000);
    } catch (e) {
      log.warn('[Сегментация] очистка:', e.message);
      showToast('Очистить маску не удалось: ' + e.message, 'error', 4000);
    }
  });

  on('btn-add-seg', 'click', () => {
    const list = $('segment-list'); if (!list) return;
    const colors = ['#ef4444', '#22c55e', '#3b82f6', '#eab308', '#8b5cf6', '#ec4899', '#06b6d4', '#f97316'];
    // [11.1.21] Номер — max существующих + 1, а не length: после удалений
    // length врал и раздавал занятые номера. Подпись — по-русски: «Segment N»
    // из JS-строки проскакивал мимо русскоязычного сторожа, который читает
    // только разметку (аудит §2.3). Слушателей на строку не вешаем — всё
    // делает делегат списка выше.
    const занятые = [...list.querySelectorAll('.seg-row')].map((r) => Number(r.dataset.segIndex) || 0);
    const индекс = (занятые.length ? Math.max(...занятые) : 0) + 1;
    const div = document.createElement('div');
    div.className = 'seg-row';
    div.dataset.segIndex = String(индекс);
    div.innerHTML = `<div class="seg-color" style="background:${colors[(индекс - 1) % colors.length]};"></div><span class="seg-label">Сегмент ${индекс}</span><button class="ann-del-btn"><svg class="ico" aria-hidden="true"><use href="#i-x"/></svg></button>`;
    list.appendChild(div);
  });
  // [11.1.21] Прежние onAll по статичным строкам и крестикам СНЯТЫ — их
  // работу целиком забрал делегат списка (см. выше): у active был бы третий
  // хозяин, а у крестиков — удаление без предупреждения о мазках.
  // Реальные Undo/Redo вместо заглушек
  on('btn-seg-undo', 'click', () => undoAnnotation());
  on('btn-seg-redo', 'click', () => redoAnnotation());
  _updateUndoRedoButtons();

  // Запускаем подписку на события аннотаций
  bindAnnotationEvents();
  bindUndoRedoKeys();
}

// ============================================================
// AI
// ============================================================
function bindAI() {
  // [10.19.29] «Проверить модели» — перенесена из Enterprise-панели в саму
  // вкладку ИИ: спрашивать про модели естественно там, где ими пользуются.
  // Показ окном, а не всплывающей плашкой на 15 секунд: список из шести строк
  // за это время не прочитать, а прокрутить плашку нельзя.
  // [11.1.29] УКАЗАТЕЛЬ ВЛАДЕНИЯ (аудит §2.4): btn-ai-release,
  // btn-ai-export-stl и btn-ai-detect-body обрабатываются в
  // proFeaturesBindings (разделы 12–14) — там живут их помощники _ai() и
  // _requireVolume, и переезд сюда тащил бы обвязку ради красоты. Двойных
  // слушателей нет — пин verify_11_1_29 пересчитывает on(«id») по всему src
  // и требует ровно одного на каждый.
  on('btn-ai-check-models', 'click', async () => {
    showToast('Проверяю модели…', 'info', 1500);
    try {
      const m = await import('../ai/aiModule.js');
      const текст = await m.сводкаПоМоделям();
      const фон = document.createElement('div');
      фон.style.cssText = 'position:fixed;inset:0;z-index:60000;background:rgba(5,8,14,0.72);display:flex;align-items:center;justify-content:center;padding:14px;';
      const к = document.createElement('div');
      к.style.cssText = 'max-width:640px;width:100%;max-height:88vh;overflow:auto;background:#0f1420;border:1px solid #2a3546;border-radius:14px;padding:16px;color:#dbe6f5;font-size:13px;line-height:1.6;white-space:pre-line;user-select:text;';
      к.textContent = текст;
      const закр = document.createElement('button');
      закр.textContent = 'Закрыть';
      закр.style.cssText = 'margin-top:12px;width:100%;padding:10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;';
      закр.addEventListener('click', () => фон.remove());
      к.appendChild(закр);
      фон.appendChild(к);
      фон.addEventListener('click', (e) => { if (e.target === фон) фон.remove(); });
      document.body.appendChild(фон);
    } catch (e) {
      showToast('Проверка моделей не удалась: ' + e.message, 'error', 6000);
    }
  });

  // [10.19.26] Кнопки-перехода btn-open-cinematic больше нет: кинематика
  // объединена с «Объём 3D» в один раздел, как и просили, — переходить некуда.
  // Контейнер #tab-cinematic остался ВНУТРИ вкладки: «Сброс» ниже находит его
  // ползунки и списки по тому же id, что и раньше.

  // [10.19.24] «Движок» ИИ (ai-backend) БЫЛ ПУСТЫШКОЙ: список рисовался, выбор
  // никуда не шёл. Теперь выбор сохраняется, ortLoader читает его при подъёме
  // рантайма (см. cinematic10/ortLoader.js), а надпись говорит правду: рантайм
  // ONNX поднимается один на страницу, поэтому смена движка вступает в силу при
  // следующей загрузке страницы — врать «переключено» мгновенным тостом нельзя.
  {
    const сп = $('ai-backend');
    if (сп) {
      try {
        const сохранён = localStorage.getItem('mikhmel.ortBackend');
        if (сохранён && [...сп.options].some((o) => o.value === сохранён)) сп.value = сохранён;
      } catch (e) { log.debug('[ИИ/движок]', e.message); }
      сп.addEventListener('change', () => {
        try { localStorage.setItem('mikhmel.ortBackend', сп.value); } catch (e) { log.debug('[ИИ/движок]', e.message); }
        const текущий = getOrtBackend?.();
        if (текущий && текущий !== сп.value) {
          showToast(`Выбор запомнен: ${сп.value.toUpperCase()}. Сейчас работает ${текущий.toUpperCase()}; `
            + 'рантайм ONNX один на страницу, смена вступит в силу после перезагрузки страницы.', 'info', 7000);
        } else {
          showToast(`Движок ИИ: ${сп.value.toUpperCase()}. Применится при первом запуске ИИ.`, 'success', 4000);
        }
      });
    }
  }

  // [10.19.24] «Авто-наложение» (ai-auto-overlay) БЫЛО МЕРТВО — это было прямо
  // записано в enterprisePanel.js: «галочка ai-auto-overlay в сайдбаре мертва».
  // Теперь переключатель управляет тем, накладывается ли маска сегментации на
  // срезы ПОСЛЕ расчёта (единственная точка наложения —
  // applyLabelMapToCornerstone в clinicalTools.js, она флаг и читает). Числа
  // и объёмы считаются в любом случае — переключатель только про картинку.
  {
    const т = $('ai-auto-overlay');
    if (т) {
      // [11.1.35] Метка хозяина: общий перещёлкиватель bindToggles щёлкал
      // класс ВТОРЫМ и разводил вид тумблера с состоянием в localStorage.
      т.dataset.хозяин = 'featureBindings/АвтоНаложение';
      const прочитать = () => { try { return localStorage.getItem('mikhmel.aiAutoOverlay') !== 'off'; } catch (e) { return true; } };
      const показать = (в) => { т.classList.toggle('on', в); т.setAttribute('aria-checked', String(в)); };
      показать(прочитать());
      т.addEventListener('click', () => {
        const в = !прочитать();
        try { localStorage.setItem('mikhmel.aiAutoOverlay', в ? 'on' : 'off'); } catch (e) { log.debug('[ИИ/наложение]', e.message); }
        показать(в);
        showToast(в ? 'Маска сегментации будет накладываться на срезы после расчёта'
          : 'Наложение после расчёта отключено: числа считаются, картинка не трогается', 'info', 4000);
      });
    }
  }

  onAll('.ai-run-btn[data-model]', 'click', async (e) => {
    const modelId = e.currentTarget.dataset.model;
    const card = e.currentTarget.closest('.ai-card');
    const bar = card?.querySelector('.ai-progress-bar');
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.textContent = '⏳ ...';
    if (bar) bar.style.width = '10%';

    try {
      // ── 1. Получить viewport и данные ──
      const vpIds = getViewportIds ? getViewportIds() : [];
      const activeVpId = vpIds[0];
      if (!activeVpId) { showToast('⚠️ Сначала загрузите DICOM-исследование', 'warning'); return; }

      const re = getRenderingEngine();
      const vp = re?.getViewport(activeVpId);
      if (!vp) { showToast('⚠️ Окно не инициализирован', 'warning'); return; }

      showToast(`🤖 Запуск ${modelId}...`, 'info');
      if (bar) bar.style.width = '20%';

      // ── 2. Получить данные объёма (CS3D v2 compatible) ──
      const volumeInfo = _ctx.getVolumeScalarData();
      const hasVolume = !!(volumeInfo && volumeInfo.scalarData && volumeInfo.dimensions);

      // ── 3. Попытка ONNX → fallback на алгоритм ──
      let useAlgorithm = typeof hasAlgorithmicFallback === 'function' ? hasAlgorithmicFallback(modelId) : false;
      let onnxAvailable = false;

      // Проверим ONNX только если модель зарегистрирована
      try {
        onnxAvailable = await isModelAvailable(modelId);
      } catch(e) { log.debug("[FeatureBindings] ONNX not available:", e.message); }

      // [10.19.24] ONNX-путём для моделей БЕЗ алгоритмического отката владеет
      // клинический модуль (clinicalTools.js, слушатель на тех же кнопках).
      //
      // ПОВОД — проверка «все ли кнопки работают» нашла ДВОЙНОЙ ЗАПУСК: на одной
      // кнопке висели два обработчика с зеркальными условиями, и для «Лёгких»
      // (lung-seg — единственная модель без отката) срабатывали ОБА: этот — с
      // упрощённой подгонкой всего объёма, и клинический — с честным трёхмерным
      // проходом по срезам и наложением маски. Две сегментации на одно нажатие.
      // Владелец теперь один: клинический путь полнее (3D-цикл, наложение,
      // объёмы долей), этот обработчик ONNX-без-отката не трогает.
      if (onnxAvailable && !useAlgorithm) {
        if (!document.body?.dataset?.clinicalToolsReady) {
          showToast('Этой моделью владеет клинический модуль, а он не загрузился — подробности в журнале', 'warning', 6000);
        }
        return;
      }

      // Если ONNX есть — используем его (lung-seg → lungmask)
      // [10.19.24] Прежние ONNX-ветки (общая и отдельная для lung-seg) отсюда
      // УДАЛЕНЫ: после передачи владения клиническому модулю (ранний return
      // выше) они стали недостижимы, а мёртвый код с видом живого — это то,
      // за чем однажды придёт правка не туда.

      // ── 4. АЛГОРИТМИЧЕСКИЙ FALLBACK ──
      if (!useAlgorithm) {
        showToast(`⚠️ Модель "${modelId}" — нет ONNX-файла и нет алгоритмического запасной путь`, 'warning', 6000);
        return;
      }

      if (!hasVolume) {
        showToast('⚠️ Загрузите КТ-серию в режиме объём/MPR для AI-анализа', 'warning');
        return;
      }

      if (bar) bar.style.width = '40%';
      const { dimensions, spacing, scalarData } = volumeInfo;
      const [W, H, D] = dimensions;
      const sp = [spacing[0], spacing[1], spacing[2]];
      const pixels = scalarData instanceof Int16Array ? scalarData : new Int16Array(scalarData.buffer, scalarData.byteOffset, scalarData.length);

      if (bar) bar.style.width = '60%';

      // [10.19.19] ШКАЛА ЗНАЧЕНИЙ — до всякой сегментации.
      //
      // ПОВОД — замер приёмки: кнопки «Органы», «Мозг», «Сердце» отвечали
      // «0 мл», «Камеры не обнаружены». Формально кнопка работает; для врача это
      // выглядит как поломка. А причина в шкале: пороги заданы в единицах
      // Хаунсфилда (воздух ≈ −1000), и если объём содержит «сырые» значения без
      // пересчёта (в замере было 20…627), под порог не попадает ничего. Теперь
      // это отказ с числами, а не ноль без объяснения.
      const ПОРОГОВЫЕ = ['organ-seg', 'brain-seg', 'cardiac-seg', 'cardiac-chambers',
        'rt-contour', 'lung-nodule', 'lung-seg', 'stroke-detect', 'calcium-score'];
      if (ПОРОГОВЫЕ.includes(modelId)) {
        let мин = Infinity, макс = -Infinity;
        const шаг = Math.max(1, Math.floor(pixels.length / 20000));
        for (let i = 0; i < pixels.length; i += шаг) { const v = pixels[i]; if (v < мин) мин = v; if (v > макс) макс = v; }
        if (мин > -300) {
          showToast(`Значения объёма ${Math.round(мин)}…${Math.round(макс)} — это не шкала Хаунсфилда `
            + '(воздух должен быть около −1000). Пороговая сегментация по таким значениям ничего не найдёт: '
            + 'нужна серия КТ с пересчётом в HU (RescaleSlope/Intercept). На МРТ этот путь не работает в принципе.',
            'warning', 11000);
          if (bar) bar.style.width = '0%';
          return;
        }
      }

      // ── Роутер алгоритмов ──
      switch (modelId) {
        case 'cardiac-seg':
        case 'cardiac-chambers': {
          const result = await segmentCardiacChambers(pixels, W, H, D, sp);
          const names = Object.keys(result.chambers);
          const volumes = names.map(c => `${c}: ${result.chambers[c].volumeMl} мл`).join(', ');
          showToast(`✅ Камеры сердца: ${names.length} найдено${result.hasContrast ? ' (контраст +)' : ''}\n${volumes || 'Камеры не обнаружены'}`,
            names.length > 0 ? 'success' : 'warning', 8000
          );
          if (result.chambers.LV) {
            const ef = await estimateEF(result.chambers.LV.volumeMl);
            if (ef.method === 'volume-only') showToast(`ℹ️ LV КДО ≈ ${ef.edv} мл. Для EF нужна 2-фазная серия`, 'info', 6000);
          }
          break;
        }

        case 'organ-seg': {
          const result = await segmentOrgansByHU(pixels, W, H, D, sp);
          const info = Object.entries(result.organs).map(([name, o]) => `${name}: ${o.volumeMl} мл`).join('\n');
          showToast(`✅ Сегментация органов (HU-пороги)\n${info || 'Органы не обнаружены'}`, 'success', 10000);
          break;
        }

        case 'brain-seg': {
          const result = await segmentBrainByHU(pixels, W, H, D, sp);
          const info = Object.entries(result.regions).map(([name, r]) => `${name}: ${r.volumeMl} мл`).join('\n');
          // Индекс атрофии считался и раньше, но показывал его только ВТОРОЙ
          // обработчик той же кнопки (proFeaturesBindings). Дубликат убран, число
          // перенесено сюда — иначе оно потерялось бы вместе с ним.
          const атрофия = (result.atrophyIndex != null)
            ? `\nИндекс атрофии: ${Number(result.atrophyIndex).toFixed(2)}` : '';
          showToast(`✅ Сегментация мозга (HU-пороги)\n${info || 'Ткани мозга не обнаружены — это КТ головы?'}${атрофия}`,
            info ? 'success' : 'warning', 10000);
          break;
        }

        case 'rt-contour': {
          const result = await autoContourByThreshold(pixels, W, H, D, sp, { huMin: -100, huMax: 200, minVoxels: 100 });
          showToast(`✅ Авто-контуринг: ${result.contourCount} областей, объём ${result.volumeMl} мл`, 'success', 8000);
          break;
        }

        case 'lung-nodule': {
          const thresh = card?.querySelector('#nodule-thresh')?.value;
          const result = await detectLungNodules(pixels, W, H, D, sp, { threshold: thresh ? thresh / 100 : 0.7 });
          if (result.totalFound === 0) {
            showToast('✅ Узлы лёгких: не обнаружено (градиентный анализ)', 'success', 6000);
          } else {
            const top3 = result.nodules.slice(0, 3).map(n =>
              `⊙ ${n.diameterMm} мм, ${n.meanHU} HU — ${n.lungRADS}`
            ).join('\n');
            // Здесь стояло `результат.найдено` — переменной с таким именем в этой
            // области нет вовсе. То есть при НАЙДЕННЫХ узлах ветка падала с
            // ReferenceError, и врач вместо списка узлов получал молчание. Ошибка
            // жила ровно потому, что ветка срабатывает только когда узлы есть.
            showToast(`🔍 Найдено узлов: ${result.totalFound}\n${top3}${result.totalFound > 3 ? `\n...и ещё ${result.totalFound - 3}` : ''}`,
              'warning', 15000
            );
          }
          break;
        }

        case 'lung-seg': {
          // [11.0.2] Ветки для lung-seg не было вовсе — карточка «Лёгкие»
          // проваливалась в `default` и отвечала «Нет алгоритма для lung-seg».
          // Одновременно её слушал второй обработчик (clinicalTools.js:1215):
          // он один из семи карточек НЕ отсекался списком алгоритмических
          // откатов, лез за файлом /models/lungmask_r231.onnx и отвечал
          // «Модель не найдена». Итог: два разных отказа на один щелчок и ни
          // одного числа.
          //
          // Алгоритм не изобретаю: лёгкие уже выделяются по HU внутри
          // segmentOrgansByHU — тем же путём, каким ими пользуется
          // «Расш. анализ лёгких». Беру оттуда и показываю объёмы.
          const result = await segmentOrgansByHU(pixels, W, H, D, sp);
          const л = result.organs?.lungs;
          if (!л || !л.volumeMl) {
            showToast('Лёгкие не выделены: в объёме нет ткани с плотностью лёгких. Это КТ грудной клетки?', 'warning', 8000);
            break;
          }
          showToast(`✅ Сегментация лёгких (HU-пороги)\nОбъём: ${л.volumeMl} мл`, 'success', 8000);
          break;
        }

        case 'stroke-detect': {
          const result = await classifyStroke(pixels, W, H, D);
          const resultDiv = card?.querySelector('#stroke-result');
          const emoji = result.classification === 'Норма' ? '✅' : result.classification === 'Ишемический' ? '⚠️' : '🔴';
          const msg = `${emoji} ${result.classification} (${result.confidence}%)\nL: ${result.leftMeanHU} HU | R: ${result.rightMeanHU} HU | Δ: ${result.asymmetryHU} HU`;

          if (resultDiv) {
            resultDiv.innerHTML = `<strong style="color:${result.classification === 'Норма' ? '#0f0' : '#f55'}">${escapeHtml(result.classification)}</strong> — ${result.confidence}%`;
          }
          showToast(msg + '\n' + result.note, result.classification === 'Норма' ? 'success' : 'warning', 12000);
          break;
        }

        default:
          showToast(`⚠️ Нет алгоритма для ${modelId}`, 'warning');
      }

      if (bar) bar.style.width = '100%';

    } catch (err) {
      const msg = err.message || String(err);
      if (msg.includes('ALGORITHMIC_FALLBACK')) {
        showToast(`ℹ️ ONNX не найдена, используется алгоритмический метод`, 'info');
      } else {
        showToast(`❌ AI ошибка: ${msg}`, 'error', 8000);
        log.error('[AI]', err);
      }
    } finally {
      btn.disabled = false;
      btn.textContent = '▶ Запуск';
      setTimeout(() => { if (bar) bar.style.width = '0%'; }, 3000);
    }
  });
}

// ============================================================
// CINEMATIC RENDERING
// ============================================================
/**
 * [10.19.12] «Качество» → длинная сторона кадра в пикселях.
 * Ровно те числа, что написаны в списке: 256 / 512 / 1024 / 2048.
 */
const КАЧЕСТВО_В_ПИКСЕЛИ = { preview: 256, draft: 512, high: 1024, ultra: 2048 };

/**
 * [10.19.12] «Освещение» → расстановка источников света рендерера.
 *
 * Освещение в кинематографическом рендеринге — это лампы (setLights), а не
 * набор пост-эффектов, поэтому выбор идёт сюда. Координаты в системе сцены,
 * intensity — яркость, radius — мягкость (чем больше, тем шире полутень).
 */
const СВЕТ = {
  studio:   [{ position: [3, 3, 4],  intensity: 1.0, color: [1, 0.96, 0.9],  radius: 14 },
             { position: [-4, 1, 2], intensity: 0.35, color: [0.85, 0.9, 1], radius: 18 }],
  surgical: [{ position: [0, 4, 1],  intensity: 1.6, color: [1, 1, 1],       radius: 8 }],
  dramatic: [{ position: [5, 2, 1],  intensity: 1.4, color: [1, 0.9, 0.75],  radius: 6 }],
  outdoor:  [{ position: [2, 6, 3],  intensity: 1.1, color: [1, 0.97, 0.88], radius: 20 },
             { position: [-3, 4, -2], intensity: 0.5, color: [0.7, 0.82, 1], radius: 25 }],
};

/**
 * [10.19.12] «Перенос» → настоящий идентификатор объёмного пресета (КТ).
 *
 * [10.19.14] МР-пункты сюда НЕ входят намеренно: у МРТ нет единиц Хаунсфилда, и
 * фиксированный пресет на другой серии дал бы другую картинку. Они идут через
 * `применитьМРПеренос`, который считает окно по гистограмме этой серии.
 */
const ПЕРЕНОС_В_ПРЕСЕТ = { ct_default: 'ct-overview', ct_bone: 'ct-bone-clean', ct_vessels: 'ct-vascular' };

/** [10.19.14] МР-переносы: считаются по гистограмме серии (core/mrNormalize.js). */
const ПЕРЕНОС_МР = { 'mr-brain': 'МР мозг', 'mr-vessels': 'МР сосуды TOF', 'mr-overview': 'МР обзор' };

/** Полоса прогресса кинематографического рендера. */
function _прогрессРендера(доля, подпись) {
  const bar = $('render-progress-bar'), val = $('render-progress-val');
  const проц = Math.max(0, Math.min(100, Math.round(доля * 100)));
  if (bar) bar.style.width = проц + '%';
  if (val) val.textContent = подпись || (проц + '%');
}

/**
 * Дождаться НАСТОЯЩЕГО кадра: счётчик кадров рендерера обязан вырасти.
 *
 * Именно здесь ловится разница между «включили» и «рисует». До 10.19.12 панель
 * ставила 100% и писала «Done» сразу после вызова, ничего не проверяя, — и на
 * машине врача это выглядело как успешный рендер при пустой полосе прогресса.
 */
function _ждатьКадрРендера(cr, ждатьМс = 8000) {
  return new Promise((resolve) => {
    const было = cr.getMetrics?.()?.totalFrames || 0;
    const t0 = Date.now();
    const тик = () => {
      const стало = cr.getMetrics?.()?.totalFrames || 0;
      if (стало > было) return resolve(стало - было);
      if (Date.now() - t0 > ждатьМс) return resolve(0);
      setTimeout(тик, 200);
    };
    тик();
  });
}

function bindCinematic() {
  let _идёт = false;

  /** Настройки из правой панели — один источник для всех кнопок. */
  /**
   * [10.19.18] Переключатели «AO» и «Тени» — по факту наличия карты глубины.
   *
   * ПОВОД. В 10.19.17 они были выключены НАСМЕРТЬ прямо в разметке: глубины не
   * существовало, и включать было нечего. Теперь глубина считается по объёму, и
   * состояние переключателей обязано следовать за фактом, а не за моим
   * предположением полугодовой давности. Подпись под ними — тоже: она либо
   * называет числа, либо называет причину отказа.
   */
  const обновитьГлубинуВПанели = (д) => {
    const ao = $('render-ao');
    const тени = $('render-shadows');
    const плашка = $('render-depth-note');
    const есть = !!д?.isUsingRealDepth;
    for (const кн of [ao, тени]) {
      if (!кн) continue;
      кн.disabled = !есть;
      кн.setAttribute('aria-disabled', есть ? 'false' : 'true');
      кн.title = есть ? 'Затенение по карте глубины' : (д?.причина || 'Карта глубины пока не посчитана');
      if (!есть) { кн.classList.remove('on'); кн.setAttribute('aria-checked', 'false'); }
    }
    if (плашка) {
      // [10.19.21] Доля нормалей — тем же языком чисел: 0% при живой глубине
      // значит, что полусферный SSAO и N·L честно работают старым путём.
      const нормали = есть && д.доляНормалей > 0
        ? `, нормалей ${((д.доляНормалей || 0) * 100).toFixed(0)}%`
        : '';
      плашка.textContent = есть
        ? `Карта глубины посчитана по объёму окна: ${д.размер || '?'}, попаданий `
          + `${((д.доляПопаданий || 0) * 100).toFixed(0)}%${нормали}, ${Math.round(д.extractionTimeMs || 0)} мс. `
          + 'Затенение и тени работают по ней, а не по яркости картинки.'
        : `Затенение и тени требуют карты глубины. Сейчас её нет: ${д?.причина || 'причина не названа'}.`;
    }
  };
  on_(EVENTS.DEPTH_UPDATED, обновитьГлубинуВПанели);
  // Первый опрос: событие могло пройти до того, как панель подписалась.
  import('../rendering/depthExtractor.js')
    .then((м) => обновитьГлубинуВПанели(м.getDepthDiagnostics()))
    .catch(() => { /* модуль не загрузился — плашка останется исходной */ });

  const изПанели = () => ({
    качество: $('render-quality')?.value || 'high',
    освещение: $('render-lighting')?.value || 'studio',
    перенос: $('render-tf')?.value || 'ct_default',
    ao: !!$('render-ao')?.classList.contains('on'),
    тени: !!$('render-shadows')?.classList.contains('on'),
    прогресс: _прогрессРендера,
  });

  on('btn-render-start', 'click', async () => {
    if (_идёт) { showToast('Рендер уже запускается — подождите', 'info', 1500); return; }
    _идёт = true;
    const кнопка = $('btn-render-start');
    if (кнопка) кнопка.disabled = true;
    try {
      // [10.19.16] Весь путь — в ui/cinematicControl.js: там же ожидание кадра и
      // ЗАМЕР кадра. Раньше эта кнопка и кнопки «Кино вкл/выкл» шли разными
      // путями и вели себя по-разному — врач это заметил сразу.
      await включитьКино(изПанели());
    } catch (e) {
      _прогрессРендера(0);
      showToast('Ошибка рендера: ' + (e?.message || e), 'error', 7000);
      log.warn('[Cinematic]', e);
    } finally {
      _идёт = false;
      if (кнопка) кнопка.disabled = false;
    }
  });

  /**
   * [10.19.19] «Сброс» — заводские значения ТЕКУЩЕГО пресета.
   *
   * ПОВОД, прямая просьба: «в разделе Кинематический рендеринг нет кнопки СБРОС
   * для возврата установок по умолчанию». Её и правда не было: двадцать ползунков
   * тонкой настройки уводились руками, а исходные значения нужно было помнить
   * наизусть. Сброс возвращает пресет, а не «нули»: нули — это не настройки по
   * умолчанию, это отсутствие эффектов.
   */
  on('btn-render-reset', 'click', async () => {
    // [10.19.24] СБРОС — ПОЛНЫЙ: настройки И изображение.
    //
    // ПОВОД, приёмка: «кнопка СБРОС должна приводить настройки по умолчанию И
    // изображение по умолчанию, а не оставлять изображение изменённым». Прежний
    // обработчик пере-применял ТЕКУЩИЙ пресет к живому рендереру: ползунки
    // возвращались, а кинослой оставался на экране — и, хуже того,
    // ensureCinematicRenderer СОЗДАВАЛ рендерер, если его не было: кнопка
    // сброса могла что-то ВКЛЮЧИТЬ.
    //
    // Теперь порядок такой:
    //   1) кинослой снимается — на экране обычный объёмный рендер, то самое
    //      «изображение по умолчанию»;
    //   2) панель возвращается к заводским значениям ИЗ РАЗМЕТКИ
    //      (defaultValue/defaultSelected): второго списка заводских значений в
    //      коде нет, поэтому разъехаться им не с чем;
    //   3) живому рендереру (если он был) ставится заводской пресет, чтобы при
    //      следующем включении внутренние настройки не расходились с панелью;
    //      если рендерера нет — он НЕ создаётся;
    //   4) выбор движка возвращается на «авто» и в хранилище.
    выключитьКино();
    _прогрессРендера(0);

    const панель = document.getElementById('tab-cinematic');
    let ползунков = 0, списков = 0;
    if (панель) {
      for (const el of панель.querySelectorAll('input[type="range"]')) {
        if (el.value !== el.defaultValue) {
          el.value = el.defaultValue;
          el.dispatchEvent(new Event('input', { bubbles: true }));
        }
        ползунков++;
      }
      for (const el of панель.querySelectorAll('select')) {
        const заводской = [...el.options].findIndex((o) => o.defaultSelected);
        const к = заводской >= 0 ? заводской : 0;
        if (el.selectedIndex !== к) {
          el.selectedIndex = к;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
        списков++;
      }
      // AO и тени: вернуть в «выкл». Их ДОСТУПНОСТЬ и дальше решает карта
      // глубины (depth:updated) — сброс трогает только состояние.
      for (const ид of ['render-ao', 'render-shadows']) {
        const т = document.getElementById(ид);
        if (т?.classList.contains('on')) {
          т.classList.remove('on');
          т.setAttribute('aria-checked', 'false');
        }
      }
    }
    try { localStorage.setItem('mikhmel.cinematicEngine', 'auto'); } catch (e) { log.debug('[Кино/сброс]', e.message); }

    // Живому рендереру — заводской пресет; несуществующий НЕ создаётся.
    const cr = getCinematicRenderer();
    if (cr && !cr.isDisposed?.()) {
      try { cr.setPreset?.('cinematic'); } catch (e) { log.debug('[Кино/сброс]', e.message); }
    }
    showToast(`Сброс выполнен: кинослой снят, на экране обычный объёмный рендер. `
      + `Панель возвращена к заводским (${ползунков} ползунков, ${списков} списков, движок «авто»).`, 'success', 5000);
  });

  /**
   * [10.19.19] Выбор движка. На RTX 4060 путь WebGPU кадра не даёт, а WebGL2
   * работает — пока причина WebGPU не найдена, у врача должен быть рычаг.
   */
  on('render-engine', 'change', async () => {
    const режим = $('render-engine')?.value || 'auto';
    try { localStorage.setItem('mikhmel.cinematicEngine', режим); } catch (e) { log.debug('[Кино/движок]', e.message); }
    if (режим !== 'webgl2') {
      showToast('Движок: авто. Смена вступит в силу при следующем включении рендера.', 'info', 5000);
      return;
    }
    const { рендерер: cr } = ensureCinematicRenderer();
    if (!cr) { showToast('Движок запомнен: WebGL2. Применится при включении рендера.', 'info', 4000); return; }
    const р = await cr.перейтиНаWebGL2?.('выбор в панели');
    showToast(р?.success ? 'Движок переключён на WebGL2' : 'Переключить не удалось: ' + (р?.error || 'причина не названа'),
      р?.success ? 'success' : 'error', 5000);
  });

  /**
   * [10.19.20] Отчёт WebGPU. Печатается в консоль и копируется в буфер: врач
   * присылает его одним сообщением, и путь WebGPU перестаёт чиниться вслепую.
   */
  on('btn-webgpu-diag', 'click', async () => {
    const кнопка = $('btn-webgpu-diag');
    if (кнопка) { кнопка.disabled = true; }
    showToast('Собираю отчёт WebGPU: адаптер, возможности, каждый проход по одному…', 'info', 4000);
    try {
      const м = await import('../rendering/webgpuDiag.js');
      const итог = await м.диагностикаWebGPU({ рендерер: getCinematicRenderer() });
      console.log(итог.текст);
      let вБуфере = false;
      try { await navigator.clipboard.writeText(итог.текст); вБуфере = true; } catch (e) { log.debug('[WebGPU/отчёт]', e.message); }
      const битых = (итог.данные?.проходы || []).filter((п) => п.ошибки.length).length;
      if (!итог.ок) {
        showToast('Отчёт готов: ' + (итог.причина || 'WebGPU недоступен') + '. Полный текст — в консоли (F12)'
          + (вБуфере ? ' и в буфере обмена.' : '.'), 'warning', 9000);
      } else {
        showToast(`Отчёт WebGPU готов: проходов с ошибками ${битых} из ${итог.данные?.проходы?.length ?? 0}. `
          + `Полный текст — в консоли (F12)${вБуфере ? ' и в буфере обмена' : ''}. Пришлите его целиком.`,
          битых ? 'warning' : 'success', 10000);
      }
    } catch (e) {
      showToast('Отчёт WebGPU не собрался: ' + e.message, 'error', 8000);
      log.warn('[WebGPU/отчёт]', e);
    } finally {
      if (кнопка) кнопка.disabled = false;
    }
  });

  on('btn-render-stop', 'click', () => {
    const дескриптор = _ctx.getCinematicHandle?.();
    if (дескриптор) {
      try { дескриптор.stop(); } catch (e) { log.debug('[Cinematic] stop:', e.message); }
      _ctx.setCinematicHandle(null);
      showToast('Запись остановлена', 'info', 2500);
    }
    выключитьКино();
    _прогрессРендера(0);
  });

  // [10.19.16] Кнопка «Кино вкл/выкл» — тот же путь: она была пустышкой,
  // печатала «включён», а isEnabled() оставался false.
  // [10.19.19] Из левого сайдбара кнопку убрали совсем (просьба врача: «может она
  // вообще в этом разделе не нужна»), обработчик оставлен для оставшейся.
  for (const ид of ['btn-cinematic-toggle']) {
    on(ид, 'click', async () => {
      const кнопка = $(ид);
      if (кнопка) кнопка.disabled = true;
      try {
        const итог = await переключитьКино(изПанели());
        if (кнопка) кнопка.classList.toggle('active', !!итог.включено);
      } finally {
        if (кнопка) кнопка.disabled = false;
      }
    });
  }

  // 3D Renderer presets
  onAll('.preset-chip[data-render-preset]', 'click', (e) => {
    const preset = e.currentTarget.dataset.renderPreset;
    // [FIX-P1] Используем единую карту пресетов
    const p = _ctx.VRT_PRESET_MAP[preset] || { cs3d: 'CT-Chest', ww: 400, wc: 40 };
    // [10.0.2] В своё окно, а не во все шесть сразу.
    applyRenderPreset(p.cs3d, { ww: p.ww, wc: p.wc });
    $$('.preset-chip[data-render-preset]').forEach(c => c.classList.remove('active'));
    e.currentTarget.classList.add('active');
    showToast(`Пресет: ${preset}`, 'info', 1200);
  });
}

// ============================================================
// FUSION / 4D
// ============================================================
// [10.19.30] Куст «оверлей-фьюжн» 7.0.51 ВЫКОРЧЕВАН ЦЕЛИКОМ: все пять его
// обработчиков висели на кнопках-призраках — id btn-apply-fusion, btn-load-pet,
// btn-load-ct-fusion, fusion-opacity и fusion-colormap в разметке отсутствуют
// давно. Хуже: плашки-подсказки отправляли к кнопке «Наложить фьюжн», которой
// не существует. Живой путь слияния ПЭТ-КТ ОДИН — раздел «Слияние PET-CT»
// (ds-petct-*, кнопка «Применить») в proFeaturesBindings → DatasetManager.
// Само слово «фьюжн» из плашек переведено: «слияние» — перевод владельца;
// моё промежуточное «наложение» описывало механизм показа, а не операцию.

function bindFusion4D() {
  // [7.0.50] CINE → реальный движок startCine/stopCine (как в enterprisePanel). null = активный вьюпорт.
  // [10.19.32] Сирота btn-cine-show-bar удалён: кнопки нет в разметке.
  // Кино-панель показывает живая кнопка тулбара btn-cine-toolbar (toolBindings).
}

// ============================================================
// GPU COMPUTE
// ============================================================
function bindGPUCompute() {
  // [10.19.29] Раздел «GPU вычисления» разобран кнопка за кнопкой. Нашлось два
  // рода бед, и обе молчаливые.
  //
  // 1. ДВЕ КНОПКИ ИЗ ТРЁХ ЗВАЛИ РАСЧЁТ С НЕВЕРНЫМИ АРГУМЕНТАМИ. Подписи:
  //      runMarchingCubes(volumeData, dims, isoValue, cacheKey)
  //      runThreshold(volumeData, lower, upper, cacheKey)
  //    А звали их так:
  //      runMarchingCubes(scalarData, dims, spacing, iso)  → isoValue = spacing (массив!)
  //      runThreshold(scalarData, dims, low, high)         → lower = dims (массив!)
  //    То есть порог сравнивал яркость с массивом, поверхность строилась по
  //    «изозначению»-массиву. Ошибки не было: сравнение с NaN просто не
  //    срабатывает, и кнопка бодро печатала «готов».
  //
  // 2. РЕЗУЛЬТАТ НИКУДА НЕ ШЁЛ. Все три расчёта возвращают данные (MIP —
  //    картинку, поверхность — вершины, порог — маску), а обработчик их
  //    выбрасывал и показывал «готов». Считать минуту и выбросить — это не
  //    работа, а её вид. Теперь результат ПОКАЗЫВАЕТСЯ: MIP рисуется на холсте
  //    в окне, поверхность отдаёт число треугольников и выгрузку STL, порог —
  //    объём в миллилитрах и долю кадра.
  // [10.19.30] окноРезультата вынесено на уровень модуля (см. _окноРезультата
  // выше): тем же окном теперь пользуется DSA-вычитание.

  on('btn-run-mip', 'click', async () => {
    const axis = parseInt($('mip-axis')?.value || '0');
    const vi = _ctx.getVolumeScalarData();
    if (!vi) { showToast('MIP: сначала загрузите объём', 'warning', 3000); return; }
    showToast('Считаю MIP…', 'info', 1500);
    const t0 = Date.now();
    try {
      const r = await (await _gpu()).runMIP(vi.scalarData, vi.dimensions, axis);
      if (!r?.data?.length) { showToast('MIP не посчитан: расчёт вернул пустой результат', 'error', 5000); return; }
      // Показ: проекция рисуется на холсте с растяжкой по своим min/max —
      // иначе на экране был бы чёрный прямоугольник.
      let мин = Infinity, макс = -Infinity;
      for (const v of r.data) { if (v < мин) мин = v; if (v > макс) макс = v; }
      const разм = макс - мин || 1;
      const холст = document.createElement('canvas');
      холст.width = r.width; холст.height = r.height;
      холст.style.cssText = 'max-width:100%;height:auto;image-rendering:pixelated;border:1px solid #2a3546;border-radius:8px;';
      const ctx2 = холст.getContext('2d');
      const img = ctx2.createImageData(r.width, r.height);
      for (let i = 0; i < r.data.length; i++) {
        const g = Math.round(((r.data[i] - мин) / разм) * 255);
        img.data[i * 4] = img.data[i * 4 + 1] = img.data[i * 4 + 2] = g;
        img.data[i * 4 + 3] = 255;
      }
      ctx2.putImageData(img, 0, 0);
      const w = _окноРезультата(`MIP · ось ${['аксиальная', 'сагиттальная', 'корональная'][axis] || axis}`);
      w.тело.appendChild(холст);
      w.тело.insertAdjacentHTML('beforeend',
        `<div style="margin-top:8px;color:#9fb3cf;">Размер ${r.width}×${r.height} · яркости ${Math.round(мин)}…${Math.round(макс)} · `
        + `${r.gpu ? 'считала видеокарта' : 'считал процессор'} · ${((Date.now() - t0) / 1000).toFixed(1)} с</div>`
        + '<div style="margin-top:6px;color:#8fa3c0;">Это отдельная проекция для просмотра: в окна просмотра она не подставляется и на измерения не влияет. Не для диагностики.</div>');
      w.тело.appendChild(w.закрыть);
    } catch (e) {
      showToast('MIP: ' + e.message, 'error', 5000);
    }
  });

  on('btn-run-mc', 'click', async () => {
    const vi = _ctx.getVolumeScalarData();
    if (!vi) { showToast('Поверхность: сначала загрузите объём', 'warning', 3000); return; }
    const iso = parseInt($('mc-iso')?.value || '300');
    showToast(`Строю поверхность по ISO ${iso}…`, 'info', 2000);
    const t0 = Date.now();
    try {
      // [10.19.29] Аргументы по подписи: (данные, размеры, ИЗОЗНАЧЕНИЕ).
      // Здесь стояло vi.spacing на месте изозначения — сюда и уходил шаг вокселя.
      const r = await (await _gpu()).runMarchingCubes(vi.scalarData, vi.dimensions, iso);
      // [10.19.30] Процессорный откат в gpuCompute — НЕ marching cubes, а
      // точечное приближение: по одной точке на приграничную ячейку, без
      // треугольников. Выдавать его число за «треугольники» и сшивать точки в
      // STL значило бы отдать врачу файл-обманку с тостом «сохранён». На
      // машине без WebGPU честно отказываем и объясняем, чем это отличается.
      if (r && r.gpu === false) {
        const ячеек = r.vertexCount || 0;
        const w = _окноРезультата(`Поверхность · ISO ${iso} — только оценка`);
        w.тело.insertAdjacentHTML('beforeend',
          `<div>На этой машине нет WebGPU, и настоящий marching cubes не считается. `
          + `Процессорный путь лишь ОЦЕНИВАЕТ границу: приграничных ячеек при ISO ${iso} — <b>${ячеек.toLocaleString('ru-RU')}</b>.</div>`
          + '<div style="margin-top:6px;color:#8fa3c0;">Треугольников здесь нет, поэтому и выгрузки STL нет: файл из этих точек был бы обманкой. '
          + 'Настоящая сетка с STL строится процессорным путём РАЗДЕЛОМ НИЖЕ — «3D модель: обработка и выгрузка» (в 11.0.9 он переехал сюда из меню «Инструменты») — или здесь же на машине с WebGPU.</div>');
        w.тело.appendChild(w.закрыть);
        return;
      }
      const треуг = Math.floor((r?.vertexCount || 0) / 3);
      if (!треуг) {
        showToast(`Поверхность пуста: при ISO ${iso} в объёме нет границы. Попробуйте другое значение — для костей 300…700, для кожи около −300`, 'warning', 8000);
        return;
      }
      // [11.1.22] СВЕДЕНИЕ (по слову владельца): построенное здесь кладётся
      // в общий кэш ряда «3D модель: обработка и выгрузка». Суп с видеокарты
      // конвертируется в points/polys с переводом ВОКСЕЛЕЙ В МИЛЛИМЕТРЫ —
      // без умножения на шаг среза модель по Z была бы сплющена, и STL лгал
      // бы геометрией.
      let подхват = '';
      try {
        const vtk = гпуСупВVtk(r.vertices, r.vertexCount, vi.spacing || [1, 1, 1]);
        if (vtk && положитьСетку(vi.scalarData, { points: vtk.points, polys: vtk.polys }, vtk.triangleCount, `построена в «GPU Вычислениях», ISO ${iso}`)) {
          подхват = ' Раздел «3D модель: обработка и выгрузка» ниже подхватит её без пересчёта — Децимация, GLTF, VRML и STL возьмут именно эту сетку.';
        }
      } catch (e) { log.debug('[GPU→сетка] конвертация:', e.message); }
      const w = _окноРезультата(`Поверхность · ISO ${iso}`);
      w.тело.insertAdjacentHTML('beforeend',
        `<div>Треугольников: <b>${треуг.toLocaleString('ru-RU')}</b> · вершин ${r.vertexCount.toLocaleString('ru-RU')} · `
        + `${r.gpu ? 'считала видеокарта' : 'считал процессор'} · ${((Date.now() - t0) / 1000).toFixed(1)} с</div>`
        + `<div style="margin-top:6px;color:#8fa3c0;">Сетка построена в памяти. В окна просмотра она не подставляется — объёмный вид рисуется своим путём; забрать её можно файлом STL.${подхват}</div>`);
      const стл = document.createElement('button');
      стл.textContent = 'Сохранить STL';
      стл.style.cssText = 'margin-top:10px;width:100%;padding:10px;border-radius:8px;border:1px solid #2a3546;background:#1a2332;color:#dbe6f5;';
      стл.addEventListener('click', () => {
        // [11.1.23] STL пишется В МИЛЛИМЕТРАХ из уже сконвертированной сетки
        // (та же, что ушла в кэш обработки): прежний писатель брал сырые
        // r.vertices в ВОКСЕЛЯХ — при срезе 0.7×0.7×3 модель по Z была
        // сплющена вчетверо. Нормали считаются заново из мм-точек: старые,
        // вексельные, после анизотропного масштаба лгали бы направлением.
        const vtkСетка = гпуСупВVtk(r.vertices, r.vertexCount, vi.spacing || [1, 1, 1]);
        if (!vtkСетка) { showToast('Сетка пуста — сохранять нечего', 'warning', 2500); return; }
        const P = vtkСетка.points;
        const строки = ['solid mikhmel'];
        for (let t = 0; t < vtkСетка.triangleCount; t++) {
          const a = t * 9, b = a + 3, c = a + 6;
          const ux = P[b] - P[a], uy = P[b + 1] - P[a + 1], uz = P[b + 2] - P[a + 2];
          const vx = P[c] - P[a], vy = P[c + 1] - P[a + 1], vz = P[c + 2] - P[a + 2];
          let nx = uy * vz - uz * vy, ny = uz * vx - ux * vz, nz = ux * vy - uy * vx;
          const дл = Math.hypot(nx, ny, nz) || 1;
          nx /= дл; ny /= дл; nz /= дл;
          строки.push(`facet normal ${nx} ${ny} ${nz}`, ' outer loop');
          for (const j of [a, b, c]) {
            строки.push(`  vertex ${P[j]} ${P[j + 1]} ${P[j + 2]}`);
          }
          строки.push(' endloop', 'endfacet');
        }
        строки.push('endsolid mikhmel');
        downloadBlob(new Blob([строки.join('\n')], { type: 'model/stl' }), `surface_iso${iso}_${Date.now()}.stl`);
        showToast('STL сохранён — в миллиметрах', 'success', 1800);
      });
      w.тело.appendChild(стл);
      w.тело.appendChild(w.закрыть);
    } catch (e) {
      showToast('Поверхность: ' + e.message, 'error', 5000);
    }
  });

  on('btn-run-thresh', 'click', async () => {
    const vi = _ctx.getVolumeScalarData();
    if (!vi) { showToast('Порог: сначала загрузите объём', 'warning', 3000); return; }
    const low = parseInt($('thresh-low')?.value || '100');
    const high = parseInt($('thresh-high')?.value || '500');
    if (low >= high) { showToast(`Порог: нижний (${low}) должен быть меньше верхнего (${high})`, 'warning', 4000); return; }
    showToast(`Считаю порог ${low}…${high}…`, 'info', 1500);
    const t0 = Date.now();
    try {
      // [10.19.29] Подпись: (данные, НИЖНИЙ, ВЕРХНИЙ). Здесь вторым шли
      // размеры объёма — то есть яркость сравнивалась с массивом.
      const r = await (await _gpu()).runThreshold(vi.scalarData, low, high);
      if (!r?.data?.length) { showToast('Порог не посчитан: расчёт вернул пустой результат', 'error', 5000); return; }
      let внутри = 0;
      for (const v of r.data) if (v > 0) внутри++;
      const [sx, sy, sz] = vi.spacing || [1, 1, 1];
      const мл = внутри * sx * sy * sz / 1000;
      const доля = внутри / r.data.length * 100;
      const w = _окноРезультата(`Порог ${low}…${high} HU`);
      w.тело.insertAdjacentHTML('beforeend',
        `<div>Вокселей в диапазоне: <b>${внутри.toLocaleString('ru-RU')}</b> из ${r.data.length.toLocaleString('ru-RU')} (${доля.toFixed(1)}%)</div>`
        + `<div>Объём: <b>${мл.toFixed(1)} мл</b> при шаге вокселя ${sx}×${sy}×${sz} мм</div>`
        + `<div style="color:#9fb3cf;">${r.gpu ? 'считала видеокарта' : 'считал процессор'} · ${((Date.now() - t0) / 1000).toFixed(1)} с</div>`
        + '<div style="margin-top:6px;color:#8fa3c0;">Считается весь кадр целиком, без разделения на органы: в диапазон попадает всё, что в него попадает — и кость, и стол, и контраст. Не для диагностики.</div>');
      w.тело.appendChild(w.закрыть);
    } catch (e) {
      showToast('Порог: ' + e.message, 'error', 5000);
    }
  });
}

// ============================================================
// 3D ENDOSCOPY
// ============================================================
function bindEndoscopy() {
}

// ============================================================
// MEASUREMENTS
// ============================================================
function bindMeasurements() {
  on('btn-meas-csv', 'click', () => {
    // [11.0.2] CSV собирается ИЗ ТОГО ЖЕ разбора, что и таблица на экране.
    // Раньше здесь стояло `a.data?.cachedStats?.mean` — обращение на уровень
    // выше, чем лежат числа: cachedStats это словарь «идентификатор объёма →
    // статистика», и `.mean` у самого словаря нет. В файл уходил столбец из
    // пустот, а единица измерения всегда писалась «mm», даже для углов и HU.
    const строки = _собратьИзмерения();
    const csv = 'Тип,Значение,Ед.\n' + строки.map((и) => `${и.тип},${и.значение},${и.ед}`).join('\n');
    downloadBlob(new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' }), `measurements_${Date.now()}.csv`);
    showToast(строки.length ? `📊 CSV: ${строки.length} измерений` : '📊 CSV пуст: измерений нет', строки.length ? 'success' : 'info');
  });
  // [11.1.21] Кнопка «JSON» УДАЛЕНА (аудит §1.2): она делала ровно то же,
  // что «Экспорт аннотаций» двумя разделами ниже — exportAnnotations() в
  // файл, — отличаясь лишь именем файла. Две кнопки одной работы в одной
  // вкладке. Оставлен «Экспорт аннотаций»: он парный к импорту.
  on('btn-meas-clear', 'click', () => { clearAnnotations(); showToast('Измерения очищены', 'info'); _обновитьТаблицуИзмерений(); });
  _подключитьТаблицуИзмерений();
}

// ============================================================
// ТАБЛИЦА ИЗМЕРЕНИЙ [11.0.2]
// ============================================================
/**
 * Таблица и статистика на вкладке «Измерения» НИКОГДА НЕ ЗАПОЛНЯЛИСЬ.
 *
 * Разметка была на месте с давних пор: `#measurements-body`, `#meas-count`,
 * `#meas-sum`, `#meas-mean`, `#meas-minmax`. Ни одно из этих имён не
 * встречалось в коде ни разу — проверено поиском по всему проекту. Врач делал
 * десять измерений и видел «Нет измерений» и четыре прочерка, при том что
 * кнопки CSV/JSON рядом выгружали те же самые данные.
 *
 * Сторож мёртвых органов их не ловил: он следит за КНОПКАМИ, списками и
 * полями ввода — за тем, что можно нажать. Пустая таблица нажатия не ждёт, и
 * под правило не попадала. Это не дыра в стороже, а граница его зоны: строку
 * «показывать то, что посчитано» проверкой разметки не поймать.
 */

/** Человеческие имена инструментов Cornerstone. */
const _ИМЕНА_ИНСТРУМЕНТОВ = Object.freeze({
  Length: 'Длина', Bidirectional: 'Двунаправл.', Angle: 'Угол', CobbAngle: 'Угол Кобба',
  EllipticalROI: 'Эллипс ROI', RectangleROI: 'Прямоуг. ROI', CircleROI: 'Круг ROI',
  PlanarFreehandROI: 'Свободное ROI', Probe: 'Зонд', ArrowAnnotate: 'Стрелка',
  SplineROI: 'Сплайн ROI', UltrasoundDirectional: 'УЗИ направл.',
});

/**
 * Достать из аннотации число и единицу.
 *
 * Тонкость, на которой спотыкался прежний экспорт: `cachedStats` — это НЕ
 * статистика, а СЛОВАРЬ «идентификатор объёма → статистика». У самого словаря
 * нет ни `mean`, ни `length`; они лежат внутри, под ключом вида
 * `volumeId:cornerstoneStreamingImageVolume:…`. Берём первую запись словаря:
 * измерение живёт в одном окне, и записей там ровно одна.
 */
function _числоИзмерения(ann) {
  const инстр = ann?.metadata?.toolName || '';
  const словарь = ann?.data?.cachedStats;
  const первый = словарь && typeof словарь === 'object' ? Object.values(словарь)[0] : null;
  const с = (первый && typeof первый === 'object') ? первый : {};
  const чис = (v) => (typeof v === 'number' && isFinite(v)) ? v : null;

  // Порядок важен: у ROI есть и площадь, и средняя плотность — показываем
  // площадь как основное число, плотность уводим в подпись строки.
  if (чис(с.length) != null) return { значение: с.length, ед: 'мм', подпись: '' };
  if (чис(с.angle) != null) return { значение: с.angle, ед: '°', подпись: '' };
  if (чис(с.area) != null) {
    const hu = чис(с.mean);
    return { значение: с.area, ед: 'мм²', подпись: hu != null ? `${hu.toFixed(0)} HU` : '' };
  }
  if (чис(с.length1) != null || чис(с.longestDiameter) != null) {
    const дл = чис(с.longestDiameter) ?? чис(с.length1);
    const кор = чис(с.shortestDiameter) ?? чис(с.length2);
    return { значение: дл, ед: 'мм', подпись: кор != null ? `× ${кор.toFixed(1)} мм` : '' };
  }
  if (чис(с.value) != null) return { значение: с.value, ед: 'HU', подпись: '' };   // Зонд
  if (чис(с.mean) != null) return { значение: с.mean, ед: 'HU', подпись: '' };
  // Стрелка и подписи чисел не несут — это не поломка, им нечего показывать.
  if (инстр === 'ArrowAnnotate') return { значение: null, ед: '', подпись: ann?.data?.text || '' };
  return { значение: null, ед: '', подпись: '' };
}

/** Собрать измерения в плоский список — общий источник для таблицы и CSV. */
function _собратьИзмерения() {
  let все = [];
  try { все = getAnnotations() || []; } catch (e) { log.debug('[Измерения]', e.message); return []; }
  if (!Array.isArray(все)) все = Object.values(все).flat();
  return все.map((a) => {
    const инстр = a?.metadata?.toolName || '—';
    const { значение, ед, подпись } = _числоИзмерения(a);
    return {
      uid: a?.annotationUID || '',
      тип: _ИМЕНА_ИНСТРУМЕНТОВ[инстр] || инстр,
      значение: значение != null ? Number(значение).toFixed(1) : '—',
      число: значение,
      ед, подпись,
    };
  });
}

function _обновитьТаблицуИзмерений() {
  const тело = $('measurements-body');
  if (!тело) return;
  const строки = _собратьИзмерения();

  if (!строки.length) {
    тело.innerHTML = '<tr><td colspan="4" style="padding:12px; text-align:center; color:var(--text-dim);">Нет измерений</td></tr>';
  } else {
    тело.innerHTML = строки.map((и) => `<tr data-uid="${escapeHtml(и.uid)}">`
      + `<td style="padding:4px 6px;">${escapeHtml(и.тип)}</td>`
      + `<td style="padding:4px 6px;">${escapeHtml(и.значение)}${и.подпись ? ` <span style="color:var(--text-dim);">${escapeHtml(и.подпись)}</span>` : ''}</td>`
      + `<td style="padding:4px 6px;">${escapeHtml(и.ед)}</td>`
      + '<td style="padding:4px; text-align:center;"><button class="ann-del-btn" title="Удалить измерение">✕</button></td></tr>').join('');
  }

  // ── Статистика ──
  //
  // Складывать миллиметры с градусами и единицами Хаунсфилда нельзя, а
  // прежняя разметка предлагала одну «Сумму» на всё. Поэтому считаем по
  // САМОЙ ЧАСТОЙ единице и честно подписываем, по какой именно: «сумма 43.2
  // мм» осмысленна, «сумма 43.2» — нет.
  const счётЕдиниц = {};
  for (const и of строки) if (и.число != null && и.ед) счётЕдиниц[и.ед] = (счётЕдиниц[и.ед] || 0) + 1;
  const ведущая = Object.entries(счётЕдиниц).sort((a, b) => b[1] - a[1])[0]?.[0] || '';
  const числа = строки.filter((и) => и.число != null && и.ед === ведущая).map((и) => и.число);

  const впиши = (id, текст) => { const el = $(id); if (el) el.textContent = текст; };
  впиши('meas-count', String(строки.length));
  if (!числа.length) {
    впиши('meas-sum', '—'); впиши('meas-mean', '—'); впиши('meas-minmax', '—');
  } else {
    const сумма = числа.reduce((s, v) => s + v, 0);
    впиши('meas-sum', `${сумма.toFixed(1)} ${ведущая}`);
    впиши('meas-mean', `${(сумма / числа.length).toFixed(1)} ${ведущая}`);
    впиши('meas-minmax', `${Math.min(...числа).toFixed(1)} / ${Math.max(...числа).toFixed(1)} ${ведущая}`);
  }
  // Если единиц несколько — говорим, по какой посчитано, а не молчим.
  const шапка = $('meas-count')?.closest('.ctrl-row')?.previousElementSibling;
  if (шапка && шапка.classList?.contains('section-title')) {
    const разных = Object.keys(счётЕдиниц).length;
    шапка.textContent = разных > 1 ? `Статистика (по «${ведущая}»)` : 'Статистика';
  }
}

function _подключитьТаблицуИзмерений() {
  // Крестик в строке — делегированием: строки перерисовываются целиком, и
  // вешать слушателя на каждую заново значило бы плодить их при каждом
  // обновлении.
  const тело = $('measurements-body');
  if (тело) {
    тело.addEventListener('click', (e) => {
      const кн = e.target.closest('.ann-del-btn');
      if (!кн) return;
      const uid = кн.closest('tr')?.dataset?.uid;
      if (!uid) return;
      try { removeAnnotation(uid); } catch (err) { log.debug('[Измерения] удаление:', err.message); }
      _обновитьТаблицуИзмерений();
    }, { signal: _getSignal() });
  }

  // Живое обновление по событиям самих аннотаций — тем же путём, каким
  // работает отмена/повтор (toolBindings.bindAnnotationEvents).
  const подписаться = () => {
    const csTools = window.cornerstoneTools || window.MikhmelViewer?._csTools;
    const Events = csTools?.Enums?.Events;
    if (!Events) return false;
    const цель = csTools.eventTarget || document;
    for (const имя of ['ANNOTATION_COMPLETED', 'ANNOTATION_REMOVED', 'ANNOTATION_MODIFIED']) {
      if (Events[имя]) цель.addEventListener(Events[имя], () => _обновитьТаблицуИзмерений(), { signal: _getSignal() });
    }
    log.debug('[Измерения] таблица подписана на события аннотаций');
    return true;
  };
  if (!подписаться()) {
    // Инструменты ещё не поднялись — ждём их готовности, как и соседи.
    const когдаГотовы = () => { document.removeEventListener('cornerstoneToolsReady', когдаГотовы); подписаться(); };
    document.addEventListener('cornerstoneToolsReady', когдаГотовы, { signal: _getSignal() });
    setTimeout(() => подписаться(), 3000);
  }

  // Открытие вкладки «Измерения» — тоже повод пересчитать: аннотацию могли
  // удалить с самого снимка, пока вкладка была закрыта.
  document.querySelector('.right-tab[data-tab="tab-measure"]')
    ?.addEventListener('click', () => setTimeout(_обновитьТаблицуИзмерений, 50), { signal: _getSignal() });

  _обновитьТаблицуИзмерений();
}

// ============================================================
// REPORTS
// ============================================================
// [11.1.16] Тела шаблонов. До этого выбор из двенадцати пунктов менял ОДНУ
// строку в шапке бланка («Шаблон: ct-chest») — вывеска-лайт: «CT Мозг» и
// «Маммография» давали одинаково пустой лист. Теперь выбор предзаполняет
// «Находки» скелетом разделов по модальности. Скелеты — только структура
// (заголовки с многоточиями), БЕЗ предзаполненных «норм»: писать «не
// выявлено» за врача бланк не смеет. Пустое поле заполняется молча, непустое
// — только после подтверждения. Тексты правятся прямо здесь.
const ТЕЛА_ШАБЛОНОВ = Object.freeze({
  'general': 'Область исследования: …\nКачество исследования: …\nНаходки: …\nСравнение с предыдущими исследованиями: …',
  'ct-chest': 'Лёгкие: …\nПлевральные полости: …\nСредостение и корни: …\nЛимфатические узлы: …\nСердце и сосуды: …\nКости грудной клетки и мягкие ткани: …',
  'ct-abdomen': 'Печень: …\nЖёлчный пузырь и протоки: …\nПоджелудочная железа: …\nСелезёнка: …\nПочки и надпочечники: …\nКишечник: …\nЛимфатические узлы: …\nСосуды: …\nКости и мягкие ткани: …',
  'ct-brain': 'Вещество головного мозга: …\nЖелудочковая система: …\nСрединные структуры: …\nСубарахноидальные пространства: …\nКости свода и основания черепа: …\nПридаточные пазухи: …',
  'mri-brain': 'Вещество головного мозга (T1/T2/FLAIR/DWI): …\nЖелудочковая система: …\nСрединные структуры: …\nГипофиз: …\nКраниовертебральный переход: …\nПосле контрастирования: …',
  'mri-spine': 'Статика и ось: …\nТела позвонков: …\nМежпозвонковые диски: …\nПозвоночный канал и корешковые каналы: …\nСпинной мозг: …\nПаравертебральные ткани: …',
  'mri-knee': 'Мениски (медиальный/латеральный): …\nКрестообразные связки: …\nКоллатеральные связки: …\nСуставной хрящ: …\nКостный мозг: …\nСуставная жидкость и сумки: …',
  'xr-chest': 'Лёгочные поля: …\nКорни лёгких: …\nСинусы: …\nТень сердца и средостения: …\nДиафрагма: …\nКостный каркас: …',
  'mammo': 'Тип строения (ACR): …\nОбразования: …\nКальцинаты: …\nАсимметрии и нарушения архитектоники: …\nКожа и сосок: …\nАксиллярные области: …\nКатегория BI-RADS: …',
  'us-abdomen': 'Печень (размеры, эхоструктура): …\nЖёлчный пузырь: …\nПоджелудочная железа: …\nСелезёнка: …\nПочки: …\nСвободная жидкость: …',
  'cardiac': 'Камеры сердца (размеры): …\nСократимость (глобальная/локальная): …\nКлапанный аппарат: …\nПерикард: …\nКоронарные артерии/кальциноз: …\nКрупные сосуды: …',
  // 'custom' — тела нет нарочно: «Свой» значит свой.
});

function bindReports() {
  // [11.1.16] Бланк собирается ОДНОЙ функцией для обеих кнопок. До этого
  // «Печать», стоя в форме под галочкой «Измерения», исполняла голый
  // window.print(): на бумагу шёл тёмный интерфейс, а форму и галочку читал
  // только «PDF отчёт» двумя разделами ниже. Комментарий 10.19.32 («теперь в
  // отчёт входит таблица») был правдой лишь для PDF. Теперь обе кнопки
  // печатают ОДИН И ТОТ ЖЕ бланк; разница только в доставке: PDF открывает
  // окно с кнопкой «Сохранить», Печать сразу зовёт диалог печати через
  // printUtil.openPrintWindow (с iframe-запаской от блокировщика всплывающих).
  // [11.1.19] ДАННЫЕ бланка собираются один раз и одной функцией — их едят
  // все три выхода: Печать, PDF (HTML) и DOCX. Три формы одного отчёта не
  // разъедутся по построению.
  const собратьДанныеОтчёта = () => {
    const шаблонСел = $('report-template');
    const измерения = [];
    if ($('report-inc-meas')?.checked) {
      for (const a of (getAnnotations() || [])) {
        const с = a.data?.cachedStats || {};
        const з = с.length != null ? `${(+с.length).toFixed(1)} мм`
          : с.mean != null ? `${(+с.mean).toFixed(1)} HU (сред.)`
          : с.angle != null ? `${(+с.angle).toFixed(1)}°` : '—';
        измерения.push({ инструмент: a.metadata?.toolName || '—', значение: з });
      }
    }
    const бланк = прочитатьБланк();
    const п = (id) => $(id)?.value?.trim() || '';
    // [11.1.30] Галочки разделов — воля врача. Раньше решала ПУСТОТА поля:
    // текст, оставшийся от прошлого пациента, уезжал в документ молча.
    const разделы = {};
    document.querySelectorAll('#report-sections input[data-section]')
      .forEach((г) => { разделы[г.dataset.section] = !!г.checked; });
    return {
      // Шапка учреждения — из настроек (заполняется один раз)
      учреждение: бланк.учреждение || '',
      реквизиты: бланк.реквизиты || '',
      логотип: бланк.логотип || '',
      логотипВид: логотипБланка(бланк),
      шрифты: шрифтыБланка(бланк),
      разделы,
      // [11.1.35] Отделение — ПО ЯВНОМУ ВЫБОРУ врача из списка, авто лишь по
      // умолчанию. Раньше решала модальность ПЕРВОЙ серии сеанса
      // (_модальностьСейчас берёт getAllSeries()[0]): открыл врач сперва КТ,
      // потом МРТ — и в заключение МРТ уезжало «ОТДЕЛЕНИЕ КОМПЬЮТЕРНОЙ
      // ТОМОГРАФИИ», а строки «MR = …» из настроек бланка не спасали: их
      // никто не спрашивал о НУЖНОЙ модальности. Замечание владельца.
      отделение: (() => {
        const выбор = $('report-dept')?.value || 'авто';
        return названиеОтделения(выбор === 'авто' ? _модальностьСейчас() : выбор, бланк);
      })(),
      поля: поляБланка(бланк),   // [11.1.35] поля листа — в печать и DOCX
      // Шапка исследования — автоподстановка с правкой
      patientName: п('report-patient') || ($('overlay-patient')?.textContent || ''),
      датаРождения: п('report-birth'),
      studyDate: п('report-studydate') || ($('overlay-date')?.textContent || ''),
      номерИстории: п('report-accession'),
      аппарат: п('report-device'),
      последовательности: п('report-sequences'),
      контраст: п('report-contrast'),
      modality: _модальностьСейчас(),
      // Тело
      шаблонИмя: шаблонСел?.selectedOptions?.[0]?.text || шаблонСел?.value || 'standard',
      клинические: п('report-clinical'),
      findings: п('report-findings'),
      сравнение: п('report-comparison'),
      impression: п('report-impression'),
      рекомендации: п('report-recommendations'),
      включитьИзмерения: !!$('report-inc-meas')?.checked,
      измерения,
      // Подпись
      physician: п('report-physician'),
      должность: п('report-physician-title'),
    };
  };

  const _модальностьСейчас = () => {
    try { return (_ctx?.getAllSeries?.() || []).map((с) => с.modality).filter(Boolean)[0] || ''; }
    catch (e) { return ''; }
  };

  // [11.1.20] Бланк собран по образцу настоящего заключения: шапка
  // учреждения с реквизитами и логотипом, название отделения, паспортная
  // часть (ФИО, дата рождения, дата исследования, № истории, аппарат),
  // строка «Исследование проведено в ИП», клинические данные, находки,
  // сравнение с предыдущим, ЗАКЛЮЧЕНИЕ, рекомендации и подпись с
  // должностью. Пустые разделы не печатаются — лист не должен пестреть
  // прочерками там, где врачу нечего сказать.
  const сформироватьHtmlОтчёта = () => {
    const д = собратьДанныеОтчёта();
    const э = escapeHtml;
    const абзацы = (т) => String(т || '').split('\n').filter((с) => с.trim()).map((с) => `<div>${э(с)}</div>`).join('');
    const раздел = (заг, текст) => текст?.trim() ? `<h2>${э(заг)}</h2><div class="txt">${абзацы(текст)}</div>` : '';
    // [11.1.30] Разделы — по галочкам врача (см. собратьДанныеОтчёта).
    const вкл = (к) => разделВключён(д.разделы, к);
    const измеренияHtml = д.включитьИзмерения
      ? (д.измерения.length
          ? `<h2>ИЗМЕРЕНИЯ (${д.измерения.length})</h2><table class="meas">${д.измерения.map((и) => `<tr><td>${э(и.инструмент)}</td><td>${э(и.значение)}</td></tr>`).join('')}</table>`
          : '<h2>ИЗМЕРЕНИЯ</h2><div class="txt" style="color:#666;">Измерений нет</div>')
      : '';
    // [11.1.30] Логотип: ширина в МИЛЛИМЕТРАХ и место — из настроек бланка
    // (бланк печатают на бумаге, а не смотрят в пикселях).
    const л = д.логотипВид || {};
    const лоГотов = д.логотип && л.место !== 'нет';
    const лоТег = лоГотов ? `<img src="${д.логотип}" alt="" style="width:${л.ширинаМм || 22}mm;">` : '';
    const текстШапки = `<div class="orgname">${абзацы(д.учреждение)}</div>${д.реквизиты ? `<div class="req">${абзацы(д.реквизиты)}</div>` : ''}`;
    const шапкаУчр = (д.учреждение || д.реквизиты || лоГотов) ? (
      л.место === 'сверху'
        ? `<div style="text-align:center;margin-bottom:2mm;">${лоТег}</div>${текстШапки}<hr>`
        : `<table class="org"><tr>
  ${лоГотов && л.место !== 'справа' ? `<td class="logo">${лоТег}</td>` : ''}
  <td>${текстШапки}</td>
  ${лоГотов && л.место === 'справа' ? `<td class="logo">${лоТег}</td>` : ''}
</tr></table><hr>`) : '';

    // [11.1.35] Поля — из настроек бланка (по умолчанию 15 мм = 1,5 см с
    // каждой стороны, просьба владельца). Зашитые 18 мм похоронены.
    const пл = д.поля || {};
    const мм = (v, у) => (Number.isFinite(Number(v)) && Number(v) >= 5 && Number(v) <= 40 ? Number(v) : у);
    return `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Заключение</title>
<style>
  @page { margin: ${мм(пл.верхМм, 15)}mm ${мм(пл.правоМм, 15)}mm ${мм(пл.низМм, 15)}mm ${мм(пл.левоМм, 15)}mm; size: A4; }
  body { font-family: '${д.шрифты?.телоИмя || 'Times New Roman'}', serif; font-size: ${д.шрифты?.телоПт || 12}pt; color: #111; line-height: 1.45; }
  .org, .dept { font-family: '${д.шрифты?.шапкаИмя || 'Times New Roman'}', serif; }
  .orgname { font-size: ${д.шрифты?.шапкаПт || 12}pt; }
  .org { width: 100%; border-collapse: collapse; }
  .org td { vertical-align: middle; }
  .logo { vertical-align: middle; padding: 0 3mm; }
  .orgname { text-align: center; font-weight: bold; }
  .req { text-align: center; font-size: 10pt; margin-top: 2mm; }
  hr { border: none; border-top: 1.5px solid #000; margin: 2mm 0 4mm; }
  .dept { text-align: center; font-weight: bold; font-size: 13pt; letter-spacing: .5px; margin-bottom: 6mm; }
  .pass div { margin: 1mm 0; } .pass b { display: inline-block; min-width: 46mm; }
  h2 { font-size: 12pt; margin: 5mm 0 1mm; }
  .txt div { margin: .6mm 0; text-align: justify; }
  .meas { border-collapse: collapse; font-size: 11pt; }
  .meas td { border: 1px solid #bbb; padding: 1mm 3mm; }
  .concl { font-weight: bold; }
  .sig { margin-top: 12mm; text-align: right; }
  .sig .post { font-weight: bold; }
  @media print { .no-print { display: none; } }
</style></head><body>
<div class="no-print" style="text-align:center;margin-bottom:6mm;">
  <button onclick="window.print()" style="padding:8px 24px;font-size:14px;cursor:pointer;background:#3b82f6;color:#fff;border:none;border-radius:6px;">📄 Сохранить PDF / Печать</button>
</div>
${шапкаУчр}
${д.отделение ? `<div class="dept">${э(д.отделение)}</div>` : ''}
<div class="pass">
  <div><b>Ф.И.О. пациента:</b> ${э(д.patientName || '—')}</div>
  ${д.датаРождения ? `<div><b>Дата рождения:</b> ${э(д.датаРождения)}</div>` : ''}
  <div><b>Дата исследования:</b> ${э(д.studyDate || '—')}</div>
  ${д.номерИстории ? `<div><b>№ истории болезни:</b> ${э(д.номерИстории)}</div>` : ''}
  ${д.аппарат ? `<div><b>Аппарат:</b> ${э(д.аппарат)}</div>` : ''}
</div>
${вкл('ип') && д.последовательности ? `<div class="txt" style="margin-top:5mm;">Исследование проведено в ИП: ${э(д.последовательности)}.</div>` : ''}
${вкл('ип') && д.контраст ? `<div class="txt">Контрастирование: ${э(д.контраст)}.</div>` : ''}
${вкл('клинические') ? раздел('КЛИНИЧЕСКИЕ ДАННЫЕ', д.клинические) : ''}
${вкл('описание') ? раздел('ОПИСАНИЕ', д.findings || '—') : ''}
${вкл('измерения') ? измеренияHtml : ''}
${вкл('сравнение') ? раздел('СРАВНЕНИЕ С ПРЕДЫДУЩИМ ИССЛЕДОВАНИЕМ', д.сравнение) : ''}
<h2>ЗАКЛЮЧЕНИЕ:</h2><div class="txt concl">${абзацы(д.impression || '—')}</div>
${вкл('рекомендации') ? раздел('РЕКОМЕНДАЦИИ', д.рекомендации) : ''}
<div class="sig">
  ${д.должность ? `<div class="post">${э(д.должность)}</div>` : ''}
  <div>${э(д.physician || '___________________')}</div>
</div>
</body></html>`;
  };

  on('btn-report-pdf', 'click', async () => {
    // [11.1.18] Первое замечание владельца: в настольной сборке «PDF отчёт»
    // говорил «всплывающие окна заблокированы» — оболочка честно запрещает
    // window.open (setWindowOpenHandler → deny). Открыватель exportModule
    // идёт тремя дверями по старшинству: родная Electron (printToPDF +
    // диалог сохранения), браузерная (window.open blob), запасная
    // (iframe-печать, где «Сохранить как PDF» выбирается в диалоге).
    const printHtml = сформироватьHtmlОтчёта();
    const дверь = await открытьПечатное(printHtml, 'width=800,height=600',
      прочитатьБланк().открыватьПослеСохранения !== false);   // [11.1.30]
    if (дверь === 'window') showToast('📄 Отчёт открыт — нажмите "Сохранить PDF"', 'success', 3000);
    if (дверь !== 'none') отметитьЭкспорт('PDF отчёт', '');
  });

  on('btn-report-print', 'click', () => {
    const via = openPrintWindow(сформироватьHtmlОтчёта(), window);
    if (via === 'none') { showToast('❌ Окно печати не открылось', 'error'); return; }
    отметитьЭкспорт('печать бланка', '');
    showToast('🖨 Бланк отчёта отправлен на печать', 'success', 2500);
  });

  // [11.1.20] Автозаполнение паспортной части из тегов открытого
  // исследования. Половина шапки живого бланка (ФИО, дата рождения, дата
  // исследования, № истории = AccessionNumber, аппарат = производитель +
  // модель + поле в теслах, перечень ИП = описания серий, препарат
  // контраста) уже лежит в памяти программы — раньше просто никуда не
  // подавалась. Поля остаются правимыми: часть ПАКС пишет имя транслитом,
  // и последнее слово за врачом.
  // [11.1.35] Список отделений в форме заключения. Первый пункт — «авто»:
  // модальность текущего исследования, как раньше. Остальные — все строки
  // «MR = НАЗВАНИЕ» из настроек бланка, слитые с заготовками: врач ВЫБИРАЕТ,
  // а не гадает, почему в МРТ-заключении оказалась компьютерная томография
  // (см. надгробие у поля «отделение» в собратьДанныеОтчёта).
  const _наполнитьОтделения = () => {
    const сел = $('report-dept');
    if (!сел) return;
    const было = сел.value || 'авто';
    const бланк = прочитатьБланк();
    const карта = { ...ОТДЕЛЕНИЕ_ПО_УМОЛЧАНИЮ, ...(бланк.отделения || {}) };
    const авто = названиеОтделения(_модальностьСейчас(), бланк);
    const экрА = (т) => String(т).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    сел.innerHTML = `<option value="авто">авто${авто ? ` — ${экрА(авто)}` : ' (по модальности исследования)'}</option>`
      + Object.entries(карта).map(([к, з]) => `<option value="${экрА(к)}">${экрА(к)} — ${экрА(з)}</option>`).join('');
    if ([...сел.options].some((о) => о.value === было)) сел.value = было;
  };
  _наполнитьОтделения();
  on('report-dept', 'focus', _наполнитьОтделения);   // список свеж к моменту выбора

  const заполнитьИзСнимка = async ({ тихо = false } = {}) => {
    try {
      const серии = _ctx?.getAllSeries?.() || [];
      if (!серии.length) { if (!тихо) showToast('Сначала откройте исследование', 'warning', 2500); return false; }
      const uid = серии[0]?.seriesUID;
      const ids = uid ? (getSeriesImageIds(uid) || []) : [];
      const теги = ids.length ? await getDICOMTags(ids[0]) : {};
      const ш = собратьШапку(теги, серии);
      const поставить = (id, зн) => {
        const эл = $(id);
        if (эл && зн && !эл.value.trim()) эл.value = зн;   // не затираем правку врача
      };
      поставить('report-patient', formatPatientName(ш.фио) || ш.фио);
      поставить('report-birth', ш.датаРождения);
      поставить('report-studydate', ш.датаИсследования);
      поставить('report-accession', ш.номерИстории);
      поставить('report-device', ш.аппарат);
      поставить('report-sequences', ш.последовательности);
      поставить('report-contrast', ш.контраст);
      if (!тихо) showToast('Паспортная часть заполнена из снимка — проверьте и правьте', 'success', 3000);
      return true;
    } catch (e) {
      if (!тихо) showToast('Не удалось прочитать теги: ' + e.message, 'error', 3500);
      return false;
    }
  };
  on('btn-report-autofill', 'click', () => заполнитьИзСнимка());

  // [11.1.30] Готовые наборы. Текст снятых разделов НЕ стирается: вернул
  // галочку — всё на месте.
  const _применитьНабор = (имя) => {
    const н = НАБОРЫ_РАЗДЕЛОВ[имя] || {};
    document.querySelectorAll('#report-sections input[data-section]')
      .forEach((г) => { г.checked = н[г.dataset.section] !== false; });
    showToast(имя === 'кратко' ? 'Набор «Кратко»: Описание и Заключение' : 'Набор «Полный»: все разделы', 'info', 1800);
  };
  // ══ [11.1.31] СОХРАНЁННЫЕ ЗАКЛЮЧЕНИЯ ══
  const _вФормуЗаключение = (д) => {
    const п = (id, зн) => { const э = $(id); if (э) э.value = зн || ''; };
    п('report-patient', д.patientName); п('report-birth', д.датаРождения);
    п('report-studydate', д.studyDate); п('report-accession', д.номерИстории);
    п('report-device', д.аппарат); п('report-sequences', д.последовательности);
    п('report-contrast', д.контраст); п('report-clinical', д.клинические);
    п('report-findings', д.findings); п('report-comparison', д.сравнение);
    п('report-impression', д.impression); п('report-recommendations', д.рекомендации);
    п('report-physician', д.physician); п('report-physician-title', д.должность);
    if (д.разделы) {
      document.querySelectorAll('#report-sections input[data-section]')
        .forEach((г) => { г.checked = д.разделы[г.dataset.section] !== false; });
    }
  };
  const _наполнитьЧерновики = (выбрать = '') => {
    const сел = $('report-draft-pick');
    if (!сел) return;
    const список = прочитатьЗаключения();
    сел.innerHTML = '<option value="">— сохранённые заключения —</option>'
      + список.map((з) => `<option value="${escapeHtml(з.ключ)}"${з.ключ === выбрать ? ' selected' : ''}>${escapeHtml(з.подпись)}</option>`).join('');
  };
  on('btn-report-draft-save', 'click', () => {
    const д = собратьДанныеОтчёта();
    const р = сохранитьЗаключение(д);
    if (!р.ок) { showToast(р.причина, 'error', 3500); return; }
    _наполнитьЧерновики(ключЗаключения(д));
    showToast(р.обновлено
      ? 'Заключение обновлено — прежняя запись этого исследования заменена'
      : `Заключение сохранено (всего ${р.всего})`, 'success', 2800);
  });
  on('btn-report-draft-load', 'click', () => {
    const з = загрузитьЗаключение($('report-draft-pick')?.value || '');
    if (!з) { showToast('Сначала выберите заключение в списке', 'info', 2200); return; }
    _вФормуЗаключение(з.данные);
    showToast(`Загружено: ${з.подпись}. Правьте и сохраняйте заново`, 'success', 3200);
  });
  on('btn-report-draft-del', 'click', () => {
    const ключ = $('report-draft-pick')?.value;
    if (!ключ) { showToast('Сначала выберите заключение в списке', 'info', 2200); return; }
    if (!confirm('Удалить это сохранённое заключение? Уже выгруженные файлы не тронутся.')) return;
    удалитьЗаключение(ключ);
    _наполнитьЧерновики();
    showToast('Заключение удалено', 'info', 1800);
  });
  on('btn-report-draft-export', 'click', () => {
    const з = загрузитьЗаключение($('report-draft-pick')?.value || '');
    if (!з) { showToast('Выберите заключение — или сперва сохраните текущее', 'info', 2500); return; }
    downloadBlob(new Blob([собратьФайлЗаключения(з)], { type: 'application/json' }), `заключение_${(з.данные.patientName || 'пациент').split(' ')[0]}_${new Date().toISOString().slice(0, 10)}.json`);
    отметитьЭкспорт('заключение (файл)', з.подпись);
  });
  on('btn-report-draft-import', 'click', () => $('report-draft-file')?.click());
  on('report-draft-file', 'change', async (e) => {
    const файл = e.target.files?.[0];
    if (!файл) return;
    const р = разобратьФайлЗаключения(await файл.text());
    e.target.value = '';
    if (!р.ок) { showToast(р.причина, 'error', 4000); return; }
    слитьЗаключения(р.записи);   // слияние, а не замена: свои записи целы
    _наполнитьЧерновики(р.записи[0].ключ);
    _вФормуЗаключение(р.записи[0].данные);
    showToast(`Загружено заключений: ${р.записи.length}. Первое подставлено в форму`, 'success', 3500);
  });
  _наполнитьЧерновики();

  on('btn-report-set-short', 'click', () => _применитьНабор('кратко'));
  on('btn-report-set-full', 'click', () => _применитьНабор('полный'));
  // Открыли вкладку «Отчёты» — заполняем молча то, что ещё пусто.
  document.querySelector('.right-tab[data-tab="tab-report"]')
    ?.addEventListener('click', () => setTimeout(() => заполнитьИзСнимка({ тихо: true }), 60), { signal: _getSignal() });

  // ── Справочник врачей и настройки бланка ──
  const наполнитьВрачей = () => {
    const сел = $('report-physician-pick');
    if (!сел) return;
    const бланк = прочитатьБланк();
    сел.innerHTML = '<option value="">— выбрать из справочника —</option>'
      + бланк.врачи.map((в, i) => `<option value="${i}">${escapeHtml(в.фио)}${в.должность ? ' — ' + escapeHtml(в.должность) : ''}</option>`).join('');
  };
  on('report-physician-pick', 'change', (e) => {
    const в = прочитатьБланк().врачи[+e.target.value];
    if (!в) return;
    if ($('report-physician')) $('report-physician').value = в.фио || '';
    if ($('report-physician-title')) $('report-physician-title').value = в.должность || '';
  });

  const разобратьПары = (текст) => String(текст || '').split('\n')
    .map((с) => с.split('='))
    .filter((ч) => ч.length >= 2 && ч[0].trim())
    .map((ч) => [ч[0].trim(), ч.slice(1).join('=').trim()]);

  const показатьНастройкиБланка = () => {
    // [11.1.31] Заполнение УБРАНО отсюда целиком: у модалки было два
    // хозяина, и побеждал этот — знавший только четыре поля, отчего шрифты
    // и вид логотипа оставались пустыми на экране (замечание владельца).
    // Теперь наполняет один — sidebarBindings, где эти поля и живут.
    window.__mikhmelЗаполнитьБланк?.();
    _ctx?.openModal?.('modal-report-blank');
  };
  on('btn-report-blank-setup', 'click', показатьНастройкиБланка);
  // [11.1.31] Видимая кнопка обзора: голое input[type=file] в проекте скрыто
  // общим правилом стиля — потому поле и не показывалось.
  on('btn-blank-logo-pick', 'click', () => $('blank-logo-file')?.click());
  on('blank-logo-file', 'change', (e) => {
    const файл = e.target.files?.[0];
    if (!файл) return;
    if (файл.size > 512 * 1024) { showToast('Логотип крупнее 512 КБ — возьмите файл поменьше', 'warning', 3500); return; }
    const ч = new FileReader();
    ч.onload = () => {
      const п = $('blank-logo-prev');
      if (п) { п.src = String(ч.result); п.style.display = ''; }
      const имя = $('blank-logo-name');
      if (имя) имя.textContent = файл.name;
    };
    ч.readAsDataURL(файл);
  });
  on('blank-logo-clear', 'click', () => {
    const п = $('blank-logo-prev');
    if (п) { п.src = ''; п.style.display = 'none'; }
    const имя = $('blank-logo-name');
    if (имя) имя.textContent = 'файл не выбран';
  });
  on('btn-blank-save', 'click', () => {
    const б = {
      // [11.1.30] Вид логотипа, шрифты, автооткрытие и набор разделов —
      // части ОДНОГО бланка: в профиль они должны попадать вместе с шапкой,
      // иначе перенос на другой компьютер привезёт герб без оформления.
      логотипВид: {
        ширинаМм: Number($('blank-logo-width')?.value) || 22,
        место: $('blank-logo-place')?.value || 'слева',
      },
      шрифты: {
        шапкаИмя: $('blank-font-head')?.value || 'Times New Roman',
        шапкаПт: Number($('blank-font-head-size')?.value) || 12,
        телоИмя: $('blank-font-body')?.value || 'Times New Roman',
        телоПт: Number($('blank-font-body-size')?.value) || 12,
      },
      открыватьПослеСохранения: $('blank-open-after-save') ? !!$('blank-open-after-save').checked : true,
      // [11.1.35] Поля листа: одно число на печать и Word (просьба владельца)
      поля: {
        верхМм: Number($('blank-margin-top')?.value) || 15,
        низМм: Number($('blank-margin-bottom')?.value) || 15,
        левоМм: Number($('blank-margin-left')?.value) || 15,
        правоМм: Number($('blank-margin-right')?.value) || 15,
      },
      разделы: Object.fromEntries([...document.querySelectorAll('#report-sections input[data-section]')]
        .map((г) => [г.dataset.section, !!г.checked])),
      учреждение: $('blank-org')?.value || '',
      реквизиты: $('blank-req')?.value || '',
      логотип: $('blank-logo-prev')?.src?.startsWith('data:') ? $('blank-logo-prev').src : '',
      отделения: Object.fromEntries(разобратьПары($('blank-depts')?.value).map(([к, з]) => [к.toUpperCase(), з])),
      врачи: разобратьПары($('blank-docs')?.value).map(([фио, должность]) => ({ фио, должность })),
    };
    if (!записатьБланк(б)) { showToast('Не удалось сохранить (приватный режим?)', 'error', 3000); return; }
    наполнитьВрачей();
    _наполнитьОтделения();   // [11.1.35] новые строки «MR = …» сразу в списке формы
    _ctx?.closeModal?.('modal-report-blank');
    showToast('Бланк сохранён — он подставляется во все заключения', 'success', 2500);
  });
  наполнитьВрачей();

  // [11.1.19] Предложение владельца: бланк в DOCX. Кириллица тут верна ПО
  // ПОСТРОЕНИЮ (document.xml — обычный UTF-8), а главное — файл открывается
  // в Word и ДОПИСЫВАЕТСЯ. PDF остаётся рядом как формат обмена/печати.
  on('btn-report-docx', 'click', async () => {
    try {
      const д = собратьДанныеОтчёта();
      const имя = `Заключение_${(д.patientName || 'пациент').split(' ')[0]}_${new Date().toISOString().slice(0, 10)}.docx`;
      const хотятОткрыть = прочитатьБланк().открыватьПослеСохранения !== false;
      const дверь = window.MikhmelDesktop?.saveReportFile;
      if (дверь) {
        // [11.1.30] Настольный путь: байты → системный диалог → запись →
        // открытие в Word. Браузерное «скачать в Загрузки» пути не даёт, а
        // без пути открывать нечего — поэтому в оболочке ходим этой дверью.
        const байты = await собратьDocxБайты(д);
        const р = await дверь(имя, байты, хотятОткрыть);
        if (!р?.saved) {
          showToast(р?.error ? '❌ Не сохранилось: ' + р.error : 'Сохранение отменено', р?.error ? 'error' : 'info', 2500);
          return;
        }
        отметитьЭкспорт('DOCX отчёт', имя, байты.length / 1048576);
        showToast(хотятОткрыть ? '📝 Заключение сохранено и открыто в Word' : '📝 Заключение сохранено: ' + р.path, 'success', 3000);
        return;
      }
      // Браузер: файл уходит в «Загрузки», и открыть его САМА СТРАНИЦА НЕ
      // МОЖЕТ — это запрет безопасности, а не наша недоработка. Говорим
      // правду вместо обещания.
      const размер = await скачатьDocxОтчёт(д, имя);
      отметитьЭкспорт('DOCX отчёт', имя, размер / 1048576);
      showToast(хотятОткрыть
        ? '📝 Заключение сохранено в «Загрузки». Открыть файл сама страница не может — это запрет браузера; откройте из папки загрузок'
        : '📝 Заключение сохранено в «Загрузки»', 'success', хотятОткрыть ? 5000 : 2500);
    } catch (e) { showToast('❌ DOCX не собрался: ' + e.message, 'error', 4000); }
  });

  // [11.1.16] Предзаполнение «Находок» скелетом выбранного шаблона.
  on('report-template', 'change', (e) => {
    const тело = ТЕЛА_ШАБЛОНОВ[e.target.value];
    const поле = $('report-findings');
    if (!тело || !поле) return;
    if (поле.value.trim() && !confirm('Заменить текст «Находок» скелетом шаблона?')) return;
    поле.value = тело;
  });
}

// ============================================================
// COMPARISON
// ============================================================
function bindComparison() {
  let _comparisonMode = 'off';
  let _раскладкаДоСравнения = null;   // [11.1.16] куда возвращаться при «Выкл.»
  let _priorViewportId = null;
  let _priorImageIds = [];
  let _syncScrollHandler = null;

  on('comparison-mode', 'change', (e) => {
    _comparisonMode = e.target.value;
    if (_comparisonMode === 'off') {
      disableComparison();
      showToast('Сравнение отключено', 'info', 800);
    } else {
      showToast(`Сравнение: ${_comparisonMode} — загрузите предыдущее исследование`, 'info');
    }
  });

  on('btn-load-prior', 'click', () => {
    // [11.1.16] Кнопка уважает селектор: раньше при «Выкл.» она всё равно
    // строила сравнение — селектор говорил одно, экран делал другое. Нажатие
    // на «Загрузить предыдущее» — это и есть намерение сравнивать, поэтому
    // режим включается честно: и в состоянии, и В САМОМ селекторе.
    if (_comparisonMode === 'off') {
      _comparisonMode = 'side-by-side';
      const сел = $('comparison-mode');
      if (сел) сел.value = 'side-by-side';
    }
    // Создаём скрытый file input для prior study
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = '.dcm,.dicom,.dic,.DCM,application/dicom';
    input.onchange = async (e) => {
      const files = Array.from(e.target.files);
      if (!files.length) return;
      showToast(`📂 Загрузка предыдущего исследования (${files.length} файлов)...`, 'info');
      try {
        await loadPriorStudy(files);
      } catch (err) {
        showToast(`❌ Ошибка: ${err.message}`, 'error');
      }
    };
    input.click();
  });

  async function loadPriorStudy(files) {
    // Загружаем файлы через существующий loader
    // [FIX-P3] loadDICOMFiles возвращает объект {seriesUID: {…}}, НЕ {seriesUIDs: [...]}
    const result = await loadDICOMFiles(files);
    const seriesUIDs = result ? Object.keys(result) : [];
    if (seriesUIDs.length === 0) {
      showToast('❌ Не найдены DICOM серии в файлах', 'error');
      return;
    }

    const priorSeriesUID = seriesUIDs[0];
    _priorImageIds = getSeriesImageIds(priorSeriesUID);

    if (_priorImageIds.length === 0) {
      showToast('❌ Серия пуста', 'error');
      return;
    }

    // [11.1.16] Раскладка ДО сравнения запоминается — выключение вернёт её,
    // а не выкинет в жёсткое 1×1 (на десктопе по умолчанию открыт MPR:
    // «Выкл.» стоил врачу трёх окон реформатов). Запоминаем только при ВХОДЕ
    // в сравнение: повторная загрузка prior поверх идущего сравнения не
    // должна затирать настоящую «прежнюю» раскладку двухоконной.
    if (!_priorViewportId) {
      _раскладкаДоСравнения = _ctx?.getCurrentLayout?.() || null;
    }
    // Переключаем layout на 1x2
    changeLayout('1x2');
    await new Promise(r => setTimeout(r, 300));

    // Загружаем prior в правый viewport
    const vpIds = getViewportIds();
    if (vpIds.length >= 2) {
      _priorViewportId = vpIds[1];
      await loadStack(_priorViewportId, _priorImageIds);

      // Синхронизируем скролл между viewport'ами
      enableSyncScroll(vpIds[0], vpIds[1]);

      showToast(`✅ Сравнение: ${_priorImageIds.length} срезов загружено`, 'success');
    }
  }

  function enableSyncScroll(vpId1, vpId2) {
    disableSyncScroll();
    const re = getRenderingEngine();
    if (!re) return;

    // Общая логика синхронизации
    const syncFromTo = (sourceId, targetId) => {
      try {
        const sourceVp = re.getViewport(sourceId);
        const targetVp = re.getViewport(targetId);
        if (!sourceVp || !targetVp) return;
        const srcIdx = sourceVp.getCurrentImageIdIndex?.() || 0;
        const srcTotal = sourceVp.getImageIds?.()?.length || 1;
        const tgtTotal = targetVp.getImageIds?.()?.length || 1;
        const tgtIdx = Math.round((srcIdx / srcTotal) * tgtTotal);
        targetVp.setImageIdIndex?.(Math.min(tgtIdx, tgtTotal - 1));
        targetVp.render();
      } catch (err) { log.debug('[Features]', err.message); }
    };

    // #15: Подписываемся через Cornerstone eventTarget (надёжнее setTimeout)
    _syncScrollHandler = (evt) => {
      const detail = evt.detail || {};
      const vpId = detail.viewportId;
      if (vpId === vpId1) syncFromTo(vpId1, vpId2);
      else if (vpId === vpId2) syncFromTo(vpId2, vpId1);
    };

    try {
      const csCore = window.cornerstone || (window.MikhmelViewer?._csCore);
      const stackEvent = csCore?.Enums?.Events?.STACK_NEW_IMAGE;
      if (stackEvent && csCore?.eventTarget) {
        csCore.eventTarget.addEventListener(stackEvent, _syncScrollHandler);
        log.debug('[Comparison] Sync via Cornerstone STACK_NEW_IMAGE event');
      }
    } catch (e) { log.debug('[FeatureBindings]', e.message); }

    // Fallback: DOM event на viewport container
    const vc = $('viewport-container');
    if (vc) vc.addEventListener('STACK_NEW_IMAGE', _syncScrollHandler);
  }

  function disableSyncScroll() {
    if (_syncScrollHandler) {
      // Отписываемся от Cornerstone eventTarget
      try {
        const csCore = window.cornerstone || (window.MikhmelViewer?._csCore);
        const stackEvent = csCore?.Enums?.Events?.STACK_NEW_IMAGE;
        if (stackEvent && csCore?.eventTarget) {
          csCore.eventTarget.removeEventListener(stackEvent, _syncScrollHandler);
        }
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
      // Отписываемся от DOM
      const vc = $('viewport-container');
      if (vc) vc.removeEventListener('STACK_NEW_IMAGE', _syncScrollHandler);
    }
    _syncScrollHandler = null;
  }

  function disableComparison() {
    disableSyncScroll();
    _priorViewportId = null;
    _priorImageIds = [];
    // [11.1.16] Возврат к раскладке, что была ДО сравнения. 1×1 остаётся
    // только запаской на случай, когда сравнение включили раньше, чем
    // раскладка успела определиться.
    changeLayout(_раскладкаДоСравнения || '1x1');
    _раскладкаДоСравнения = null;
  }
}

// ============================================================
// MULTI-MONITOR
// ============================================================
function bindMultiMonitor() {
  on('btn-detach-viewport', 'click', () => {
    const win = window.open('', '_blank', 'width=800,height=600');
    if (win) {
      win.document.title = 'Mikhmel — Detached Viewport';
      win.document.body.style.cssText = 'margin:0; background:#000; display:flex; align-items:center; justify-content:center; height:100vh; color:#fff; font-family:system-ui;';
      win.document.body.innerHTML = '<div style="text-align:center;"><h2>🖥️ Detached Viewport</h2><p>Viewport content syncs from main window</p></div>';
      showToast('🖥️ Окно отсоединено', 'success');
    }
  });
}

// ============================================================
// SYNCHRONIZER
// ============================================================
function bindSynchronizer() {
  // Toggles already bound via bindToggles
  // State is read from toggle.classList.contains('on') when needed
}

// ============================================================
// SLAB / THICKNESS
// ============================================================
// [11.0.2] bindSlabControls УДАЛЕНА. Вся её работа состояла из одной строки:
// список «Режим» менял всплывающую плашку с собственным названием и НЕ трогал
// проекцию. Это вывеска — та самая порода, что выкорчёвывалась весь месяц.
// Настоящее переключение проекции живёт в proFeaturesBindings
// (btn-pro-slab-mip / minip / avg / cycle → viewportEffects.setSlabProjection).

// ============================================================
// CLINICAL TOOLS
// ============================================================
function bindClinicalTools() {
  // [REFACTOR] Единый источник привязки — никаких stub-обработчиков, никакого cloneNode.
  // Кнопки disabled до загрузки clinicalTools.js, затем привязываются реальные обработчики.
  const CLINICAL_BTNS = [
    // [10.19.28] Пять незаконченных кнопок удалены из программы — их id ушли
    // и отсюда: список включает/выключает кнопки на время загрузки модуля, и
    // ссылки на несуществующие элементы делали бы его молча неполным.
    'btn-agatston','btn-ctr','btn-emphysema',
    'btn-pneumothorax','btn-bmd',
    'btn-aorta-diameter','btn-medsam','btn-fracture-detect',
    'btn-sam-undo','btn-sam-clear','btn-sam-run','btn-region-grow'
  ];

  // Шаг 1: disable все кнопки пока модуль грузится
  CLINICAL_BTNS.forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      el.disabled = true;
      el.style.opacity = '0.5';
    }
  });

  // Шаг 2: загрузить реальный модуль — единственный источник обработчиков
  import('./clinicalTools.js').then(m => {
    if (m?.bindAllClinicalTools) {
      m.bindAllClinicalTools(() => _ctx.getCurrentVolumeId());
      // [10.19.24] Флаг «клинический модуль на месте»: по нему bindAI понимает,
      // что ONNX-моделями без отката есть кому владеть (см. ранний return там).
      try { document.body.dataset.clinicalToolsReady = '1'; } catch (e) { /* */ }
      // Шаг 3: enable кнопки
      CLINICAL_BTNS.forEach(id => {
        const el = document.getElementById(id);
        if (el) {
          el.disabled = false;
          el.style.opacity = '';
        }
      });
      log.debug('[UI] clinicalTools.js loaded — real AI tools active');
    }
  }).catch(() => {
    // Модуль недоступен — пометить кнопки как "в разработке"
    const STUB_BTNS = ['btn-ctr', 'btn-emphysema'];
    CLINICAL_BTNS.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.disabled = false;
        el.style.opacity = '';
        if (STUB_BTNS.includes(id)) {
          el.classList.add('stub-btn');
          el.title = (el.title || el.textContent.trim()) + ' (в разработке)';
        } else {
          // Fallback: показать toast при клике
          el.addEventListener('click', () => showToast('⚠️ Модуль клинических инструментов не загружен', 'warning'), { once: true });
        }
      }
    });
    log.debug('[UI] clinicalTools.js not found — buttons in fallback mode');
  });
}

// ============================================================
// SPECIAL MODES
// ============================================================
function bindSpecialModes() {
  // [10.3.5] Здесь был список из девяти кнопок, которым проставляли пометку
  // «(в разработке)». Восемь из них были обещанием без исполнения: нажатие
  // показывало тост и на этом всё — ни DSA, ни стоматологической панорамы, ни
  // экспорта NIfTI / RT-STRUCT / MP4, ни эндоскопии, ни обзорного скана, ни
  // удаления костей не происходило. Кнопки убраны из разметки вместе с
  // обработчиками: пустая кнопка в медицинской программе хуже, чем её
  // отсутствие — врач на неё рассчитывает.
  //
  // Девятая, btn-export-stl, из списка убрана по другой причине: у неё есть
  // НАСТОЯЩИЙ обработчик (инлайновый модуль в index.html → exportSTL из
  // vtkModule), и пометка «в разработке» на ней была неправдой.
  //
  // Помечать больше нечего, поэтому и списка нет.

  // ── ВЫКЛЮЧАТЕЛИ ОСЕЙ ОТСЕЧЕНИЯ [10.19.30] ─────────────────────────────
  // Были украшением: щёлкали классом (общий bindToggles), а плоскость стояла
  // по одному значению ползунка — выключить срез выключателем было НЕЛЬЗЯ.
  // Теперь выключатель зовёт setClipAxisEnabled: ось снимается сразу, значение
  // ползунка сохраняется, повторное включение возвращает срез на место.
  // Движение ползунка включает свою ось само (двигать выключенный срез —
  // бессмыслица) и подсвечивает выключатель, чтобы показ не расходился с делом.
  for (const ось of ['x', 'y', 'z']) {
    _ownToggle(`clip-${ось}-on`, (вкл) => { setClipAxisEnabled(ось, вкл); });
    on(`clip-${ось}`, 'input', () => {
      const т = $(`clip-${ось}-on`);
      if (т && !т.classList.contains('on')) { т.classList.add('on'); т.setAttribute('aria-checked', 'true'); }
      // Само отсечение ставит слушатель в sidebarBindings; здесь — только ось.
    });
  }

  // ── АВТОВРАЩЕНИЕ И «ПОВОРОТНЫЙ» [10.19.30] ────────────────────────────
  // Оба выключателя ничего не крутили. Теперь: «Автовращение» облетает камерой
  // объёмного окна точку фокуса (18°/с, по часам, а не по кадрам); «Поворотный»
  // задаёт характер облёта — гончарный круг вокруг оси Z мира с ровным
  // горизонтом, либо свободная орбита вокруг текущей вертикали камеры.
  // Без объёмного окна включение ОТКАЗЫВАЕТ с объяснением, а не делает вид.
  _ownToggle('toggle-autospin', (вкл) => {
    if (вкл) {
      // [10.19.31] Два двигателя не крутят одну камеру: перед стартом глушим
      // кнопочное вращение из левого сайдбара (Гориз./Верт., viewportCamera).
      for (const id of getViewportIds() || []) { try { stopAutoRotate(id); } catch (e) { /* окна без вращения */ } }
      if (!startAutoSpin()) {
        showToast('Автовращение: нет объёмного окна — откройте раскладку с 3D', 'warning', 3500);
        return false; // отказ: выключатель остаётся выключенным
      }
    } else {
      stopAutoSpin();
    }
  });
  _ownToggle('toggle-turntable', (вкл) => {
    setAutoSpinTurntable(вкл);
    if (isAutoSpinOn()) showToast(вкл ? 'Поворотный: гончарный круг, горизонт ровный' : 'Поворотный выключен: свободная орбита', 'info', 2000);
  });

  // ── УМНЫЙ W/L [10.19.30] ──────────────────────────────────────────────
  // Подпись «Кликните по ткани для определения» висела при выключателе,
  // который никого не слушал. Теперь режим настоящий: пока включён, клик по
  // снимку берёт пробу 7×7 вокруг точки, по медиане ОПРЕДЕЛЯЕТ ткань и ставит
  // окно её класса: лёгкое (≤ −300 HU) → WW 1500 / WL −600, кость (≥ 200 HU)
  // → WW 1800 / WL 400, между ними — мягкие ткани, WW 350 и WL по самой пробе.
  // Границы — это радиологические соглашения по HU, а не подгонка: воздух в
  // лёгком глубоко отрицателен, губчатая кость начинается за +200.
  // Если включён «ROI W/L» (он ведёт окно по разбросу области), уступаем ему.
  {
    let _smartOn = false;
    const _вк = $('viewport-container');
    const _проба = (e) => {
      if (!_smartOn) return;
      if ($('btn-roi-wl')?.classList.contains('active')) return; // ROI W/L главнее
      try {
        const re = getRenderingEngine();
        const vpId = _ctx.getCurrentViewportId?.() || getViewportIds()[0];
        const vp = re?.getViewport(vpId);
        const vi = _ctx.getVolumeScalarData();
        if (!vp || !vi) return;
        const rect = _вк.getBoundingClientRect();
        const dims = vi.dimensions;
        const px = Math.floor((e.clientX - rect.left) / _вк.clientWidth * dims[0]);
        const py = Math.floor((e.clientY - rect.top) / _вк.clientHeight * dims[1]);
        const slice = vp.getCurrentImageIdIndex?.() || 0;
        const vals = [];
        for (let dy = -3; dy <= 3; dy++) for (let dx = -3; dx <= 3; dx++) {
          const ix = px + dx, iy = py + dy;
          if (ix >= 0 && ix < dims[0] && iy >= 0 && iy < dims[1]) vals.push(vi.scalarData[slice * dims[0] * dims[1] + iy * dims[0] + ix]);
        }
        if (!vals.length) return;
        vals.sort((a, b) => a - b);
        const мед = vals[Math.floor(vals.length / 2)];
        let ww, wl, ткань;
        if (мед <= -300) { ww = 1500; wl = -600; ткань = 'лёгкое'; }
        else if (мед >= 200) { ww = 1800; wl = 400; ткань = 'кость'; }
        else { ww = 350; wl = Math.round(мед); ткань = 'мягкие ткани'; }
        vp.setProperties?.({ voiRange: { lower: wl - ww / 2, upper: wl + ww / 2 } });
        vp.render();
        showToast(`Умный W/L: ${ткань} (медиана ${Math.round(мед)} HU) → WW ${ww} / WL ${wl}`, 'success', 2500);
      } catch (err) { log.warn('[SmartWL]', err); }
    };
    _ownToggle('toggle-smart-wl', (вкл) => {
      if (!_вк) return false;
      _smartOn = вкл;
      if (вкл) { _вк.addEventListener('click', _проба); _вк.style.cursor = 'crosshair'; showToast('Умный W/L: кликните по ткани — лёгкое, мягкие или кость', 'info', 2500); }
      else { _вк.removeEventListener('click', _проба); _вк.style.cursor = ''; }
    });
  }

  // ── DSA: ВЫЧИТАНИЕ ДВУХ ОБЪЁМОВ [10.19.30] ────────────────────────────
  // Раздел стоял мёртвым с 10.3.5: списки «— выбрать —» никто не заполнял,
  // «Усиление» меняло только цифру. Теперь вычитание настоящее и работает по
  // УЖЕ ПОСТРОЕННЫМ объёмам (реестр volumeRegistry — основной том, наложение
  // добавленный «Слиянием PET-CT», предыдущий из «Сравнения»): контраст −
  // маска, воксель
  // к вокселю, разность умножается на усиление и показывается MIP-картинкой —
  // это и есть классический вид субтракционной ангиограммы. Разные размеры
  // объёмов — честный отказ с обоими размерами: без совмещения такое
  // вычитание было бы кашей, а совмещение здесь не делается и не обещано.
  {
    const _списки = () => [$('dsa-mask-series'), $('dsa-contrast-series')];
    const _объём = (vid) => {
      try { return window.cornerstone?.cache?.getVolume?.(vid) || null; } catch (e) { return null; }
    };
    const _заполнить = () => {
      const ids = knownVolumeIds();
      for (const сп of _списки()) {
        if (!сп) continue;
        const было = сп.value;
        сп.innerHTML = '<option value="">— выбрать —</option>';
        for (const vid of ids) {
          const v = _объём(vid);
          const d = v?.dimensions;
          const о = document.createElement('option');
          о.value = vid;
          const хвост = String(vid).split(/[:/]/).pop().slice(-24);
          о.textContent = d ? `${хвост} · ${d[0]}×${d[1]}×${d[2]}` : хвост;
          сп.appendChild(о);
        }
        if (было && ids.includes(было)) сп.value = было;
      }
    };
    _заполнить();
    onRegistryChange(_заполнить);
    for (const сп of _списки()) if (сп) сп.addEventListener('focus', _заполнить, { signal: _getSignal() });

    on('btn-dsa-run', 'click', async () => {
      const [мс, кс] = _списки();
      const мид = мс?.value, кид = кс?.value;
      if (!мид || !кид) { showToast('DSA: выберите обе серии — маску и контраст. В списке — уже построенные объёмы: основной, добавленный «Слиянием PET-CT» и предыдущий из «Сравнения»', 'warning', 4500); return; }
      if (мид === кид) { showToast('DSA: маска и контраст — один и тот же объём, вычитать нечего', 'warning', 3500); return; }
      const мв = _объём(мид), кв = _объём(кид);
      const мд = мв?.getScalarData?.(), кд = кв?.getScalarData?.();
      if (!мд || !кд) { showToast('DSA: не удалось прочитать данные объёма из кэша', 'error', 4000); return; }
      const dm = мв.dimensions, dk = кв.dimensions;
      if (!dm || !dk || dm[0] !== dk[0] || dm[1] !== dk[1] || dm[2] !== dk[2]) {
        showToast(`DSA: размеры не совпадают — маска ${dm?.join('×')}, контраст ${dk?.join('×')}. Вычитание воксель-к-вокселю без совмещения тут дало бы кашу`, 'error', 7000);
        return;
      }
      const усил = parseFloat($('dsa-gain')?.value || '1') || 1;
      showToast('DSA: вычитаю и строю MIP…', 'info', 1500);
      const t0 = Date.now();
      try {
        const n = кд.length;
        const разн = new Float32Array(n);
        for (let i = 0; i < n; i++) разн[i] = (кд[i] - мд[i]) * усил;
        const r = await (await _gpu()).runMIP(разн, [dk[0], dk[1], dk[2]], 0);
        if (!r?.data?.length) { showToast('DSA: MIP разности вернул пустой результат', 'error', 5000); return; }
        let мин = Infinity, макс = -Infinity;
        for (const v of r.data) { if (v < мин) мин = v; if (v > макс) макс = v; }
        const разм = макс - мин || 1;
        const холст = document.createElement('canvas');
        холст.width = r.width; холст.height = r.height;
        холст.style.cssText = 'max-width:100%;height:auto;image-rendering:pixelated;border:1px solid #2a3546;border-radius:8px;';
        const ctx2 = холст.getContext('2d');
        const img = ctx2.createImageData(r.width, r.height);
        for (let i = 0; i < r.data.length; i++) {
          const g = Math.round(((r.data[i] - мин) / разм) * 255);
          img.data[i * 4] = img.data[i * 4 + 1] = img.data[i * 4 + 2] = g;
          img.data[i * 4 + 3] = 255;
        }
        ctx2.putImageData(img, 0, 0);
        const w = _окноРезультата(`DSA · контраст − маска, усиление ×${усил.toFixed(1)}`);
        w.тело.appendChild(холст);
        w.тело.insertAdjacentHTML('beforeend',
          `<div style="margin-top:8px;color:#9fb3cf;">MIP разности · ${r.width}×${r.height} · разброс ${Math.round(мин)}…${Math.round(макс)} · `
          + `${r.gpu ? 'считала видеокарта' : 'считал процессор'} · ${((Date.now() - t0) / 1000).toFixed(1)} с</div>`
          + '<div style="margin-top:6px;color:#8fa3c0;">Вычитание воксель-к-вокселю без совмещения: любое смещение пациента между сериями останется на картинке. Не для диагностики.</div>');
        w.тело.appendChild(w.закрыть);
      } catch (e) {
        showToast('DSA: ' + e.message, 'error', 5000);
      }
    });
  }

  // Clipping
  on('btn-remove-table', 'click', () => {
    // Удаление стола пациента: анализируем нижнюю часть volume
    const re = getRenderingEngine();
    if (!re) { showToast('⚠️ Нет движка отрисовки', 'error'); return; }

    // Ищем volume viewport
    let vp3d = null;
    for (const id of getViewportIds()) {
      const v = re.getViewport(id);
      if (v && (v.type === 'volume3d' || v.type === 'orthographic')) { vp3d = v; break; }
    }
    if (!vp3d) { showToast('⚠️ Нужен 3D или MPR вид', 'warning'); return; }

    try {
      // [FIX] Несколько путей получения данных volume
      let data = null, dims = null, spacing = null, origin = null;
      let imageData = null, scalarsRef = null;

      // Путь 1: actors → mapper → imageData (vtk.js)
      const actors = vp3d.getActors?.() || [];
      if (actors.length) {
        const actor = actors[0]?.actor;
        const mapper = actor?.getMapper?.();
        imageData = mapper?.getInputData?.();
        if (imageData) {
          const pd = imageData.getPointData?.();
          const sc = pd?.getScalars?.();
          if (sc && typeof sc.getData === 'function') {
            data = sc.getData();
            dims = imageData.getDimensions();
            spacing = imageData.getSpacing();
            origin = imageData.getOrigin();
            scalarsRef = sc;
          }
        }
      }

      // Путь 2: volume cache → voxelManager (CS3D v2)
      if (!data && _ctx.getCurrentVolumeId()) {
        try {
          const vid = _ctx.getCurrentVolumeId().startsWith('cornerstoneStreamingImageVolume:')
            ? _ctx.getCurrentVolumeId() : `cornerstoneStreamingImageVolume:${_ctx.getCurrentVolumeId()}`;
          const vol = window.cornerstone?.cache?.getVolume?.(vid);
          if (vol) {
            try { data = vol.voxelManager?.getCompleteScalarDataArray?.(); } catch (_) { log.debug('[FeatureBindings]', _.message); }
            if (!data && vol.imageData) {
              try { data = vol.imageData.getPointData?.()?.getScalars?.()?.getData?.(); } catch (_) { log.debug('[FeatureBindings]', _.message); }
            }
            if (data) { dims = vol.dimensions; spacing = vol.spacing; origin = vol.origin; imageData = vol.imageData; }
          }
        } catch(e2) { log.warn('[RemoveTable] fallback:', e2); }
      }

      if (!data || !dims) {
        showToast('⚠️ объём не загружен. Загрузите серию в MPR.', 'warning');
        return;
      }

      const [nx, ny, nz] = dims;
      const sliceSize = nx * ny;

      // Считаем среднюю плотность каждого ряда Y на среднем Z-срезе
      const midZ = Math.floor(nz / 2);
      const rowMeans = [];
      for (let y = 0; y < ny; y++) {
        let sum = 0, count = 0;
        for (let x = Math.floor(nx * 0.2); x < Math.floor(nx * 0.8); x++) {
          const idx = midZ * sliceSize + y * nx + x;
          if (idx < data.length) { sum += data[idx]; count++; }
        }
        rowMeans.push(count ? sum / count : -1024);
      }

      // Ищем стол: снизу вверх
      let tableRow = -1;
      for (let y = ny - 1; y > ny * 0.5; y--) {
        if (rowMeans[y] > -500) {
          tableRow = y;
          while (tableRow > ny * 0.5 && rowMeans[tableRow - 1] > -200) {
            tableRow--;
          }
          break;
        }
      }

      if (tableRow > 0) {
        let zeroed = 0;
        for (let z = 0; z < nz; z++) {
          for (let y = tableRow; y < ny; y++) {
            for (let x = 0; x < nx; x++) {
              const idx = z * sliceSize + y * nx + x;
              if (idx < data.length && data[idx] > -500) {
                data[idx] = -1024;
                zeroed++;
              }
            }
          }
        }

        // Обновляем данные
        if (scalarsRef && typeof scalarsRef.modified === 'function') scalarsRef.modified();
        if (imageData && typeof imageData.modified === 'function') imageData.modified();

        // Перерисовываем все viewports
        for (const id of getViewportIds()) {
          try { re.getViewport(id)?.render(); } catch (e) { log.debug('[FeatureBindings]', e.message); }
        }

        const pct = ((ny - tableRow) / ny * 100).toFixed(0);
        showToast(`✂️ Стол удалён (${pct}% снизу, ${(zeroed/1000).toFixed(0)}K вокселей)`, 'success', 3000);
      } else {
        showToast('ℹ️ Стол не обнаружен', 'info');
      }
    } catch(e) {
      log.warn('[RemoveTable]', e);
      showToast('⚠️ Ошибка: ' + e.message, 'error');
    }
  });
  // [10.19.11] Сброс наклона тоже переехал в ui/obliqueBindings.js. Здесь он
  // только обнулял ползунки и печатал «Oblique reset» — камеру не трогал,
  // потому что её и не наклоняли. Новый сброс возвращает ЗАПОМНЕННУЮ исходную
  // ориентацию: на косой серии нули дали бы не то, с чего начали.
  // [10.19.30] Три лживых обработчика закладок УБРАНЫ. Они печатали «⭐ Срез в
  // закладках» / «⬅ Предыдущая», НИЧЕГО не делая, — и держались только на том,
  // что proFeaturesBindings позже подменял узлы через _rebind настоящими
  // обработчиками (addBookmark / navigateBookmarks из viewport.js). Подмена —
  // страховка, а не оправдание: врать до неё нельзя. Хозяин закладок один —
  // proFeaturesBindings.bindBookmarks().
  // Scout
  // Export formats
  // [10.19.10] Здесь был второй обработчик на btn-export-stl — подсказка
  // «Exporting STL...», за которой ничего не происходило. У кнопки было два
  // хозяина, и оба не работали. Единственный обработчик теперь в
  // src/ui/toolsBindings.js, рядом с glTF и VRML: сетка строится из тома.

  // Memory cleanup
  // [FIX-5] Memory cleanup — полная очистка включая кэш Cornerstone
  on('btn-memory-clean', 'click', () => _ctx.clearAllData());
}

function bindClinicalExtras() {
  bindTAVI();
  bindTAVIMeasurement();     // ПУНКТ 14
  bindROIHistogram();
  bindROIWL();
  bindContrastGraph();
  // bindAnonymize, bindQRSharing — перенесены в fileOps.js (вызываются из initFileOps)
  // [11.1.2] bindVoiceControl() больше не зовётся: привязки к кнопке нет,
  // голос включается пунктом сайдбара через переключитьГолос().
  bindWebGPUCheck();
  bindTFEditor();
  bindMeasurementTrend();    // ПУНКТ 16
  // bindLeftPanelVRT / bindLeftPanelOrient — УДАЛЕНЫ, дублировали bindVRTSection()
  window.__uiManagerReady = true;
}

// ─── TAVI ─────────────────────────────────────────────────────
function bindTAVI() {
  on('btn-tavi', 'click', () => {
    const modal = $('modal-tavi');
    if (modal) modal.classList.add('open');
  });

  on('btn-tavi-calc', 'click', () => {
    const d = parseFloat($('tavi-annulus-d')?.value) || 0;
    let p = parseFloat($('tavi-annulus-p')?.value) || 0;
    let a = parseFloat($('tavi-annulus-a')?.value) || 0;

    // Автоматический расчёт по диаметру
    if (d > 0 && p === 0) {
      p = d * Math.PI;
      const el = $('tavi-annulus-p');
      if (el) el.value = p.toFixed(1);
    }
    if (d > 0 && a === 0) {
      a = Math.PI * (d / 2) ** 2;
      const el = $('tavi-annulus-a');
      if (el) el.value = a.toFixed(1);
    }

    // Рекомендации: Edwards SAPIEN 3 / Medtronic CoreValve Evolut
    let sapien = '—', evolut = '—';
    if (d >= 18 && d < 20)       { sapien = '20mm'; evolut = '23mm'; }
    else if (d >= 20 && d < 22)  { sapien = '23mm'; evolut = '26mm'; }
    else if (d >= 22 && d < 24.5){ sapien = '23mm'; evolut = '26mm'; }
    else if (d >= 24.5 && d < 27){ sapien = '26mm'; evolut = '29mm'; }
    else if (d >= 27 && d < 29.5){ sapien = '29mm'; evolut = '34mm'; }
    else if (d >= 29.5)          { sapien = 'Вне диапазона'; evolut = '34mm (XL)'; }

    const rec = $('tavi-recommendation');
    if (rec) {
      rec.innerHTML =
        `<b>Edwards SAPIEN 3:</b> ${sapien}<br>` +
        `<b>Medtronic CoreValve Evolut:</b> ${evolut}<br>` +
        `<small style="color:var(--text-dim)">Ø ${d.toFixed(1)}мм | P=${p.toFixed(1)}мм | S=${a.toFixed(1)}мм²</small>`;
    }
    showToast(`🫀 TAVI: SAPIEN ${sapien}, Evolut ${evolut}`, 'success', 3000);
  });

  on('btn-tavi-pdf', 'click', () => {
    showToast('📄 Экспорт TAVI-отчёта в PDF...', 'info');
  });
}

// ─── ROI HISTOGRAM ────────────────────────────────────────────
function bindROIHistogram() {
  on('btn-roi-histogram', 'click', () => {
    const modal = $('modal-roi-hist');
    if (modal) modal.classList.add('open');
  });

  on('btn-rh-update', 'click', () => {
    const canvas = $('roi-hist-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // ── ПУНКТ 13: Получаем данные из ТЕКУЩЕГО СРЕЗА (CS3D v2 fix) ──
    let pixelData = null;
    let sliceInfo = '';
    try {
      const vi = _ctx.getVolumeScalarData();
      if (vi) {
        const re = getRenderingEngine();
        const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        const sliceIdx = vp?.getCurrentImageIdIndex?.() || 0;
        const dims = vi.dimensions;
        const sliceSize = dims[0] * dims[1];
        if (dims.length >= 3 && dims[2] > 1) {
          const start = sliceIdx * sliceSize;
          const end = Math.min(start + sliceSize, vi.scalarData.length);
          pixelData = vi.scalarData.slice(start, end);
          sliceInfo = ` (Срез ${sliceIdx + 1}/${dims[2]}, ${dims[0]}×${dims[1]})`;
        } else {
          pixelData = vi.scalarData;
          sliceInfo = ` (${dims[0]}×${dims[1]})`;
        }
      }
    } catch (e) {
      log.warn('ROI Hist: viewport data unavailable', e);
    }

    // Демо-данные если нет реальных
    if (!pixelData) {
      pixelData = new Float32Array(50000);
      for (let k = 0; k < pixelData.length; k++) pixelData[k] = Math.random() * 4096 - 1024;
      showToast('📊 Демо-данные (загрузите DICOM)', 'info');
      sliceInfo = ' (демо)';
    } else {
      showToast('📊 Гистограмма текущего среза' + sliceInfo, 'success', 1500);
    }

    // Статистика
    const N = pixelData.length;
    let min = Infinity, max = -Infinity, sum = 0, sumSq = 0;
    for (let i = 0; i < N; i++) {
      const v = pixelData[i];
      if (v < min) min = v;
      if (v > max) max = v;
      sum += v;
      sumSq += v * v;
    }
    const mean = sum / N;
    const std = Math.sqrt(sumSq / N - mean * mean);

    const setText = (id, txt) => { const el = $(id); if (el) el.textContent = txt; };
    setText('rh-min', `${min.toFixed(0)} HU`);
    setText('rh-max', `${max.toFixed(0)} HU`);
    setText('rh-mean', `${mean.toFixed(1)} HU`);
    setText('rh-std', std.toFixed(1));

    // Гистограмма 256 бинов
    const bins = 256;
    const range = max - min || 1;
    const hist = new Uint32Array(bins);
    for (let i = 0; i < N; i++) {
      const idx = Math.min(bins - 1, Math.floor((pixelData[i] - min) / range * bins));
      hist[idx]++;
    }
    let maxCount = 0;
    for (let i = 0; i < bins; i++) if (hist[i] > maxCount) maxCount = hist[i];

    // Рисуем
    const w = canvas.width, h = canvas.height, pad = 30;
    ctx.fillStyle = '#0a0f16';
    ctx.fillRect(0, 0, w, h);
    const barW = (w - pad * 2) / bins;
    for (let i = 0; i < bins; i++) {
      const barH = (hist[i] / maxCount) * (h - pad * 2);
      ctx.fillStyle = `hsl(${(i / bins) * 240}, 70%, 55%)`;
      ctx.fillRect(pad + i * barW, h - pad - barH, barW, barH);
    }
    // Оси
    ctx.strokeStyle = '#334';
    ctx.beginPath(); ctx.moveTo(pad, pad); ctx.lineTo(pad, h - pad); ctx.lineTo(w - pad, h - pad); ctx.stroke();
    ctx.fillStyle = '#889'; ctx.font = '9px monospace'; ctx.textAlign = 'center';
    ctx.fillText(`${min.toFixed(0)} HU`, pad + 10, h - pad + 12);
    ctx.fillText(`${max.toFixed(0)} HU`, w - pad - 10, h - pad + 12);
  });
}

// ─── ROI W/L (Smart Contrast) ─────────────────────────────────
function bindROIWL() {
  let handler = null;

  on('btn-roi-wl', 'click', () => {
    _roiWlActive = !_roiWlActive;
    const btn = $('btn-roi-wl');
    if (btn) btn.classList.toggle('active', _roiWlActive);
    const vc = $('viewport-container');
    if (!vc) return;

    if (_roiWlActive) {
      vc.style.cursor = 'crosshair';
      showToast('🎯 ROI W/L: кликните по области', 'info');
      handler = (e) => {
        if (!_roiWlActive) return;
        try {
          const re = getRenderingEngine();
          if (!re) return;
          const vpId = _ctx.getCurrentViewportId() || getViewportIds()[0];
          const vp = re.getViewport(vpId);
          if (!vp) return;
          const vi = _ctx.getVolumeScalarData();
          if (!vi) return;

          const rect = vc.getBoundingClientRect();
          const dims = vi.dimensions;
          const pxX = Math.floor((e.clientX - rect.left) / vc.clientWidth * dims[0]);
          const pxY = Math.floor((e.clientY - rect.top) / vc.clientHeight * dims[1]);

          // Собираем область 20×20
          const vals = [];
          for (let dy = -10; dy <= 10; dy++) {
            for (let dx = -10; dx <= 10; dx++) {
              const ix = pxX + dx, iy = pxY + dy;
              if (ix >= 0 && ix < dims[0] && iy >= 0 && iy < dims[1]) {
                const slice = vp.getCurrentImageIdIndex?.() || 0;
                vals.push(vi.scalarData[slice * dims[0] * dims[1] + iy * dims[0] + ix]);
              }
            }
          }
          if (vals.length > 0) {
            vals.sort((a, b) => a - b);
            const roiMin = vals[Math.floor(vals.length * 0.05)];
            const roiMax = vals[Math.floor(vals.length * 0.95)];
            const ww = roiMax - roiMin, wl = (roiMax + roiMin) / 2;
            vp.setProperties?.({ voiRange: { lower: wl - ww / 2, upper: wl + ww / 2 } });
            vp.render();
            showToast(`🎯 WW=${ww.toFixed(0)} / WL=${wl.toFixed(0)}`, 'success', 1500);
          }
        } catch (err) { log.warn('ROI W/L:', err); }
      };
      vc.addEventListener('click', handler);
    } else {
      vc.style.cursor = '';
      if (handler) { vc.removeEventListener('click', handler); handler = null; }
      showToast('🎯 ROI W/L отключён', 'info', 800);
    }
  });
}

// ─── CONTRAST GRAPH ───────────────────────────────────────────
function bindContrastGraph() {
  on('btn-contrast-graph', 'click', () => {
    const modal = $('modal-contrast-graph');
    if (modal) modal.classList.add('open');
  });

  on('btn-cg-draw', 'click', () => {
    const canvas = $('contrast-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const w = canvas.width, h = canvas.height, pad = 40;
    const huMin = parseInt($('cg-min')?.value) || -1024;
    const huMax = parseInt($('cg-max')?.value) || 3071;

    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#0a0f16';
    ctx.fillRect(0, 0, w, h);

    // Текущие W/L из viewport
    let currentWW = 400, currentWL = 40;
    try {
      const re = getRenderingEngine();
      if (re) {
        const vp = re.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        const props = vp?.getProperties?.();
        if (props?.voiRange) {
          currentWW = props.voiRange.upper - props.voiRange.lower;
          currentWL = (props.voiRange.upper + props.voiRange.lower) / 2;
        }
      }
    } catch (e) { log.debug('[FeatureBindings]', e.message); }

    const range = huMax - huMin;
    const rampLeft = (currentWL - currentWW / 2 - huMin) / range * (w - pad * 2) + pad;
    const rampRight = (currentWL + currentWW / 2 - huMin) / range * (w - pad * 2) + pad;
    const centerX = (rampLeft + rampRight) / 2;

    // Фоновый градиент
    const grad = ctx.createLinearGradient(rampLeft, 0, rampRight, 0);
    grad.addColorStop(0, 'rgba(0,157,255,0.05)');
    grad.addColorStop(0.5, 'rgba(0,157,255,0.15)');
    grad.addColorStop(1, 'rgba(0,157,255,0.05)');
    ctx.fillStyle = grad;
    ctx.fillRect(rampLeft, pad, rampRight - rampLeft, h - pad * 2);

    // Трансфер-функция
    ctx.strokeStyle = '#0af'; ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(pad, h - pad);
    ctx.lineTo(Math.max(pad, rampLeft), h - pad);
    ctx.lineTo(Math.min(w - pad, rampRight), pad);
    ctx.lineTo(w - pad, pad);
    ctx.stroke();

    // Центральная линия W/L
    ctx.strokeStyle = '#fa4'; ctx.lineWidth = 1; ctx.setLineDash([4, 4]);
    ctx.beginPath(); ctx.moveTo(centerX, pad); ctx.lineTo(centerX, h - pad); ctx.stroke();
    ctx.setLineDash([]);

    // Оси
    ctx.strokeStyle = '#334'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(pad, pad); ctx.lineTo(pad, h - pad); ctx.lineTo(w - pad, h - pad); ctx.stroke();

    // Подписи
    ctx.fillStyle = '#889'; ctx.font = '10px monospace'; ctx.textAlign = 'center';
    ctx.fillText(`${huMin} HU`, pad + 30, h - pad + 14);
    ctx.fillText(`${huMax} HU`, w - pad - 30, h - pad + 14);
    ctx.fillStyle = '#fa4'; ctx.fillText(`WL: ${currentWL.toFixed(0)}`, centerX, pad - 6);
    ctx.fillStyle = '#0af'; ctx.fillText(`WW: ${currentWW.toFixed(0)}`, centerX, h - pad + 14);

    // Y label
    ctx.save();
    ctx.translate(12, h / 2); ctx.rotate(-Math.PI / 2);
    ctx.fillStyle = '#889'; ctx.fillText('Яркость', 0, 0);
    ctx.restore();
  });
}

// ─── ANONYMIZE ────────────────────────────────────────────────
// ════════════════════════════════════════════════════════════════
// ПУНКТ 12: DICOM Structured Report Export
// ════════════════════════════════════════════════════════════════
/**
 * [6.7.18 FIX] Экспорт DICOM SR.
 *
 * БЫЛО: эта функция собирала объект и сохраняла его как **JSON**
 *   (файл `*.dicom-sr.json`), хотя кнопка называется «DICOM SR».
 *   То есть настоящий DICOM-файл не создавался вообще — получить его можно
 *   было только из панели Enterprise, где вызывался dicomSRModule.
 *   Плюс SOP Class здесь был 88.33, а в самом модуле 88.22 — расхождение.
 *
 * СТАЛО: кнопка вызывает тот же проверенный бинарный писатель
 *   (dicomSRModule), что и панель Enterprise. Один путь, один SOP Class,
 *   на выходе настоящий .dcm.
 */
async function exportDICOMSR() {
  showToast('📦 Создание DICOM SR...', 'info');

  try {
    // Собираем аннотации из Cornerstone3D
    const csTools = window.cornerstoneTools || window.MikhmelViewer?._csTools;
    let annotations = [];
    if (csTools?.annotation?.state?.getAllAnnotations) {
      annotations = csTools.annotation.state.getAllAnnotations() || [];
    }
    if (!Array.isArray(annotations) || annotations.length === 0) {
      showToast('⚠️ Нет измерений для экспорта — сделайте хотя бы одно', 'warning', 4000);
      return;
    }

    // Метаданные текущей серии
    const allSeries = _ctx.getAllSeries?.() || [];
    const series = allSeries.find(s => s.seriesUID === _ctx.getCurrentSeries?.()) || allSeries[0] || {};

    const { exportAnnotationsToDicomSR, downloadDicomSR } = await import('../io/dicomSRModule.js');
    const blob = await exportAnnotationsToDicomSR(annotations, {
      patientName: series.patientName || 'ANONYMOUS',
      patientId: series.patientId || '',
      studyUID: series.studyUID || undefined,
      modality: series.modality || 'CT',
      observerName: 'Mikhmel A.V.',
    });

    const patName = (series.patientName || 'ANON').replace(/[^a-zA-Z0-9]/g, '_').slice(0, 32);
    downloadDicomSR(blob, `SR_${patName}_${formatDate(new Date())}.dcm`);

    showToast(`✅ DICOM SR сохранён (${annotations.length} измерений, ${(blob.size / 1024).toFixed(1)} КБ)`, 'success', 3000);
  } catch (err) {
    log.error('[DICOM SR]', err);
    showToast(`❌ Ошибка экспорта SR: ${err.message}`, 'error', 5000);
  }
}

function extractMeasurement(annotation) {
  try {
    const data = annotation.data || annotation;
    if (data.cachedStats) {
      const stats = Object.values(data.cachedStats)[0] || {};
      return {
        NumericValue: stats.length || stats.area || stats.mean || 0,
        Units: stats.areaUnit || stats.unit || 'mm'
      };
    }
    if (data.length !== undefined) return { NumericValue: data.length, Units: 'mm' };
    if (data.angle !== undefined) return { NumericValue: data.angle, Units: 'deg' };
  } catch (e) { log.debug('[FeatureBindings]', e.message); }
  return { NumericValue: 0, Units: 'unknown' };
}

function generateUID() {
  return '2.25.' + Date.now() + '.' + Math.floor(Math.random() * 1e9);
}

function formatDate(d) {
  return d.getFullYear().toString() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
}

function formatTime(d) {
  return String(d.getHours()).padStart(2, '0') + String(d.getMinutes()).padStart(2, '0') + String(d.getSeconds()).padStart(2, '0');
}

function bindTAVIMeasurement() {
  // Кнопка «Измерить на изображении» в модальном окне TAVI
  const measureBtn = $('btn-tavi-measure');
  if (!measureBtn) return;

  measureBtn.addEventListener('click', () => {
    _taviMeasureMode = !_taviMeasureMode;
    measureBtn.classList.toggle('active', _taviMeasureMode);

    if (_taviMeasureMode) {
      _taviPoints = [];
      showToast('📐 Кликните по 3 точкам на изображении для измерения угла аннулуса', 'info', 4000);
      // Минимизируем модал, чтобы видеть viewport
      const modal = $('modal-tavi');
      if (modal) modal.style.opacity = '0.3';

      const vc = $('viewport-container');
      if (vc) {
        vc.style.cursor = 'crosshair';
        vc._taviClickHandler = (e) => {
          if (!_taviMeasureMode) return;
          const rect = vc.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          _taviPoints.push({ x, y });

          // Визуальный маркер точки
          const marker = document.createElement('div');
          marker.className = 'tavi-point-marker';
          marker.style.cssText = `position:absolute;left:${x - 6}px;top:${y - 6}px;width:12px;height:12px;border-radius:50%;background:rgba(255,80,80,0.9);border:2px solid #fff;z-index:25;pointer-events:none;box-shadow:0 0 8px rgba(255,0,0,0.5);`;
          marker.textContent = _taviPoints.length;
          marker.style.color = '#fff';
          marker.style.fontSize = '8px';
          marker.style.textAlign = 'center';
          marker.style.lineHeight = '12px';
          vc.appendChild(marker);

          if (_taviPoints.length === 3) {
            // Вычисляем угол между 3 точками
            const p1 = _taviPoints[0], p2 = _taviPoints[1], p3 = _taviPoints[2];
            const v1 = { x: p1.x - p2.x, y: p1.y - p2.y };
            const v2 = { x: p3.x - p2.x, y: p3.y - p2.y };
            const dot = v1.x * v2.x + v1.y * v2.y;
            const mag1 = Math.sqrt(v1.x ** 2 + v1.y ** 2);
            const mag2 = Math.sqrt(v2.x ** 2 + v2.y ** 2);
            let angle = Math.acos(Math.max(-1, Math.min(1, dot / (mag1 * mag2))));
            angle = angle * 180 / Math.PI;

            // Конвертация пикселей в мм через pixelSpacing (если доступен)
            let distance_mm = null;
            try {
              const re = getRenderingEngine();
              const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
              const imgData = vp?.getImageData?.();
              if (imgData?.spacing) {
                const sp = imgData.spacing;
                const dx = (p1.x - p3.x) * sp[0];
                const dy = (p1.y - p3.y) * sp[1];
                distance_mm = Math.sqrt(dx * dx + dy * dy);
              }
            } catch (e) { log.debug('[FeatureBindings]', e.message); }

            // Записываем в поле угла TAVI
            const angleInput = $('tavi-angle');
            if (angleInput) angleInput.value = angle.toFixed(1);

            showToast(`📐 Угол: ${angle.toFixed(1)}°` + (distance_mm ? ` | Расстояние: ${distance_mm.toFixed(1)} мм` : ''), 'success', 4000);

            // Рисуем линии угла на canvas overlay
            drawAngleOverlay(vc, _taviPoints, angle);

            // Деактивируем
            _taviMeasureMode = false;
            measureBtn.classList.remove('active');
            vc.style.cursor = '';
            vc.removeEventListener('click', vc._taviClickHandler);
            vc._taviClickHandler = null;

            // Восстанавливаем модал
            const modal = $('modal-tavi');
            if (modal) modal.style.opacity = '1';

            // Очистка маркеров через 5 сек
            setTimeout(() => {
              vc.querySelectorAll('.tavi-point-marker, .tavi-angle-canvas').forEach(el => el.remove());
            }, 5000);
          }
        };
        vc.addEventListener('click', vc._taviClickHandler);
      }
    } else {
      // Отмена
      const vc = $('viewport-container');
      if (vc) {
        vc.style.cursor = '';
        if (vc._taviClickHandler) {
          vc.removeEventListener('click', vc._taviClickHandler);
          vc._taviClickHandler = null;
        }
        vc.querySelectorAll('.tavi-point-marker, .tavi-angle-canvas').forEach(el => el.remove());
      }
      const modal = $('modal-tavi');
      if (modal) modal.style.opacity = '1';
      _taviPoints = [];
    }
  });
}

function drawAngleOverlay(container, points, angle) {
  const canvas = document.createElement('canvas');
  canvas.className = 'tavi-angle-canvas';
  canvas.width = container.clientWidth;
  canvas.height = container.clientHeight;
  canvas.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;z-index:15;pointer-events:none;';
  container.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  const [p1, p2, p3] = points;

  // Линии от vertex (p2) к p1 и p3
  ctx.strokeStyle = 'rgba(255, 80, 80, 0.9)';
  ctx.lineWidth = 2;
  ctx.setLineDash([4, 4]);
  ctx.beginPath();
  ctx.moveTo(p1.x, p1.y);
  ctx.lineTo(p2.x, p2.y);
  ctx.lineTo(p3.x, p3.y);
  ctx.stroke();

  // Дуга угла
  const radius = 30;
  const angle1 = Math.atan2(p1.y - p2.y, p1.x - p2.x);
  const angle2 = Math.atan2(p3.y - p2.y, p3.x - p2.x);
  ctx.setLineDash([]);
  ctx.strokeStyle = 'rgba(255, 200, 0, 0.9)';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(p2.x, p2.y, radius, Math.min(angle1, angle2), Math.max(angle1, angle2));
  ctx.stroke();

  // Текст угла
  ctx.fillStyle = '#ffc800';
  ctx.font = 'bold 14px monospace';
  ctx.textAlign = 'center';
  ctx.fillText(`${angle.toFixed(1)}°`, p2.x, p2.y - radius - 8);
}

function openMeasDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(MEAS_DB_NAME, MEAS_DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains('measurements')) {
        const store = db.createObjectStore('measurements', { keyPath: 'id', autoIncrement: true });
        store.createIndex('patientId', 'patientId', { unique: false });
        store.createIndex('type', 'type', { unique: false });
        store.createIndex('date', 'date', { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function saveMeasurement(measurement) {
  // measurement = { patientId, patientName, type, value, unit, location, date, seriesUID }
  const db = await openMeasDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('measurements', 'readwrite');
    tx.objectStore('measurements').add({
      ...measurement,
      date: measurement.date || new Date().toISOString(),
      savedAt: Date.now()
    });
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

async function getMeasurements(patientId, type) {
  const db = await openMeasDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction('measurements', 'readonly');
    const store = tx.objectStore('measurements');
    const idx = store.index('patientId');
    const req = idx.getAll(patientId);
    req.onsuccess = () => {
      let results = req.result;
      if (type) results = results.filter(m => m.type === type);
      results.sort((a, b) => new Date(a.date) - new Date(b.date));
      resolve(results);
    };
    req.onerror = () => reject(req.error);
  });
}

function bindMeasurementTrend() {
  // Кнопка «Сохранить измерение»
  on('btn-save-measurement', 'click', async () => {
    try {
      const series = _ctx.getAllSeries().find(s => s.seriesUID === _ctx.getCurrentSeries()) || {};

      // Собираем последнее измерение из аннотаций
      const csTools = window.cornerstoneTools || window.MikhmelViewer?._csTools;
      let annotations = [];
      if (csTools?.annotation?.state?.getAllAnnotations) {
        annotations = csTools.annotation.state.getAllAnnotations() || [];
      }

      if (annotations.length === 0) {
        showToast('❌ Нет измерений для сохранения', 'error');
        return;
      }

      const lastAnn = annotations[annotations.length - 1];
      const meas = extractMeasurement(lastAnn);

      await saveMeasurement({
        patientId: series.patientId || 'unknown',
        patientName: series.patientName || 'Unknown',
        type: lastAnn.metadata?.toolName || 'Length',
        value: meas.NumericValue,
        unit: meas.Units,
        location: lastAnn.metadata?.referencedImageId || '',
        seriesUID: _ctx.getCurrentSeries()
      });

      showToast(`✅ Измерение сохранено: ${meas.NumericValue.toFixed(1)} ${meas.Units}`, 'success');
    } catch (err) {
      showToast(`❌ Ошибка: ${err.message}`, 'error');
    }
  });

  // Кнопка «Показать тренд»
  on('btn-show-trend', 'click', async () => {
    try {
      const series = _ctx.getAllSeries().find(s => s.seriesUID === _ctx.getCurrentSeries()) || {};
      const patientId = series.patientId || 'unknown';
      const measurements = await getMeasurements(patientId);

      if (measurements.length === 0) {
        showToast('📊 Нет сохранённых измерений для этого пациента', 'info');
        return;
      }

      // Рисуем тренд в модальном окне
      showMeasurementTrendChart(measurements, series.patientName);
    } catch (err) {
      showToast(`❌ Ошибка: ${err.message}`, 'error');
    }
  });
}

function showMeasurementTrendChart(measurements, patientName) {
  // Создаём модальное окно с графиком
  let modal = $('modal-trend');
  if (!modal) {
    modal = document.createElement('div');
    modal.className = 'modal-overlay';
    modal.id = 'modal-trend';
    modal.innerHTML = `
      <div class="modal" style="min-width:600px;">
        <div class="modal-title">📈 Тренд измерений — ${patientName || ''}<button class="modal-close" data-close="modal-trend">✕</button></div>
        <canvas id="trend-canvas" width="560" height="300" style="width:100%;background:#0a0f16;border-radius:6px;"></canvas>
        <div id="trend-table" style="max-height:200px;overflow-y:auto;margin-top:8px;"></div>
        <div class="ctrl-row" style="justify-content:flex-end;margin-top:8px;">
          <button class="ctrl-btn" id="btn-trend-export">📄 Экспорт CSV</button>
          <button class="ctrl-btn" data-close="modal-trend">Закрыть</button>
        </div>
      </div>`;
    document.body.appendChild(modal);
    // Close handler
    modal.querySelector('[data-close]').addEventListener('click', () => modal.classList.remove('open'));
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.classList.remove('open'); });
  }

  modal.classList.add('open');
  const canvas = modal.querySelector('#trend-canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  const w = canvas.width, h = canvas.height, pad = 50;

  ctx.clearRect(0, 0, w, h);
  ctx.fillStyle = '#0a0f16';
  ctx.fillRect(0, 0, w, h);

  if (measurements.length === 0) return;

  // Группируем по типу
  const types = [...new Set(measurements.map(m => m.type))];
  const colors = ['#3b82f6', '#ef4444', '#22c55e', '#eab308', '#8b5cf6'];

  const allVals = measurements.map(m => m.value);
  const minVal = Math.min(...allVals) * 0.9;
  const maxVal = Math.max(...allVals) * 1.1 || 1;
  const minDate = new Date(measurements[0].date).getTime();
  const maxDate = new Date(measurements[measurements.length - 1].date).getTime();
  const dateRange = maxDate - minDate || 1;

  // Оси
  ctx.strokeStyle = '#334';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(pad, pad);
  ctx.lineTo(pad, h - pad);
  ctx.lineTo(w - pad, h - pad);
  ctx.stroke();

  // Рисуем каждый тип отдельной линией
  types.forEach((type, ti) => {
    const typeMeas = measurements.filter(m => m.type === type);
    const color = colors[ti % colors.length];

    ctx.strokeStyle = color;
    ctx.lineWidth = 2;
    ctx.beginPath();

    typeMeas.forEach((m, i) => {
      const x = pad + ((new Date(m.date).getTime() - minDate) / dateRange) * (w - pad * 2);
      const y = h - pad - ((m.value - minVal) / (maxVal - minVal)) * (h - pad * 2);
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);

      // Точки
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(x, y, 4, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.stroke();

    // Легенда
    ctx.fillStyle = color;
    ctx.font = '11px sans-serif';
    ctx.fillText(`● ${type}`, w - pad - 80, pad + 14 * (ti + 1));
  });

  // Подписи осей
  ctx.fillStyle = '#889';
  ctx.font = '9px monospace';
  ctx.textAlign = 'center';
  ctx.fillText(new Date(minDate).toLocaleDateString('ru'), pad + 20, h - pad + 14);
  ctx.fillText(new Date(maxDate).toLocaleDateString('ru'), w - pad - 20, h - pad + 14);
  ctx.textAlign = 'right';
  ctx.fillText(minVal.toFixed(1), pad - 4, h - pad);
  ctx.fillText(maxVal.toFixed(1), pad - 4, pad + 4);

  // Таблица
  const table = modal.querySelector('#trend-table');
  if (table) {
    table.innerHTML = '<table style="width:100%;font-size:11px;border-collapse:collapse;">' +
      '<tr style="color:var(--text-dim);"><th style="text-align:left;padding:2px 6px;">Дата</th><th>Тип</th><th>Значение</th><th>Единицы</th></tr>' +
      measurements.map(m => `<tr style="border-top:1px solid rgba(255,255,255,0.05);">
        <td style="padding:2px 6px;">${new Date(m.date).toLocaleDateString('ru')}</td>
        <td style="text-align:center;">${m.type}</td>
        <td style="text-align:center;font-weight:600;">${m.value.toFixed(1)}</td>
        <td style="text-align:center;">${m.unit}</td>
      </tr>`).join('') +
      '</table>';
  }

  // CSV экспорт
  const exportBtn = modal.querySelector('#btn-trend-export');
  if (exportBtn) {
    exportBtn.onclick = () => {
      const csv = 'Date,Type,Value,Unit,PatientID\n' +
        measurements.map(m => `${m.date},${m.type},${m.value},${m.unit},${m.patientId}`).join('\n');
      const blob = new Blob([csv], { type: 'text/csv' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `measurements_${patientName || 'patient'}.csv`;
      a.click();
      showToast('📄 CSV экспортирован', 'success', 1000);
    };
  }
}

// ─── VOICE CONTROL ────────────────────────────────────────────
// [11.1.2] Обёртка bindVoiceControl УДАЛЕНА: она существовала ради одной
// привязки к кнопке btn-voice-control, а кнопки больше нет — голос живёт
// пунктом «Голос: команды» в группе «Голос и жесты» правого сайдбара,
// который зовёт функцию напрямую.
/**
 * [11.1.2] Голосовые команды — ЭКСПОРТИРУЕМАЯ функция, а не обработчик кнопки.
 *
 * Кнопки btn-voice-control больше нет в разметке: голос переехал в группу
 * «Голос и жесты» правого сайдбара пунктом «Голос: команды». Группа строится
 * кодом, кнопки в index.html у неё нет — значит и щёлкать по ней неоткуда.
 * Оставить прежнюю привязку значило бы получить пункт, который молчит: ровно
 * та беда, за которую владелец справедливо назвал мёртвой синхронизацию окон.
 *
 * Возвращает true, если распознавание включилось, — чтобы вызывающая сторона
 * могла отчитаться человеку.
 */
export function переключитьГолос() {
    const SpeechRecog = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecog) {
      showToast('🎤 Браузер не поддерживает голосовое управление', 'error');
      return;
    }
    const btn = $('btn-voice-control');

    if (_voiceRecognition) {
      _voiceRecognition.stop();
      _voiceRecognition = null;
      btn?.classList.remove('active');
      showToast('🎤 Голос. управление отключено', 'info', 800);
      return;
    }

    _voiceRecognition = new SpeechRecog();
    _voiceRecognition.lang = 'ru-RU';
    _voiceRecognition.continuous = true;
    _voiceRecognition.interimResults = false;

    const commands = {
      // ── 3D пресеты ──
      'кости':        () => $$('.preset-chip[data-render-preset="ct-bone-3d"]')[0]?.click(),
      'лёгкие':       () => $$('.preset-chip[data-render-preset="ct-lung-3d"]')[0]?.click(),
      'сосуды':       () => $$('.preset-chip[data-render-preset="ct-vascular"]')[0]?.click(),
      'мозг':         () => $$('.preset-chip[data-render-preset="mri-brain-3d"]')[0]?.click(),
      'сердце':       () => $$('.preset-chip[data-render-preset="cardiac-3d"]')[0]?.click(),
      'кожа':         () => $$('.preset-chip[data-render-preset="ct-skin"]')[0]?.click(),
      // ── Проекции ──
      'аксиальный':   () => $('btn-mode-axial')?.click(),
      'сагиттальный': () => $('btn-mode-sagittal')?.click(),
      'корональный':  () => $('btn-mode-coronal')?.click(),
      'объём':        () => $('btn-mode-3d')?.click(),
      '3d':           () => $('btn-mode-3d')?.click(),
      '2d':           () => $('btn-mode-2d')?.click(),
      // ── Действия ──
      'инверсия':     () => $('btn-invert')?.click(),
      'снимок':       () => $('btn-screenshot')?.click(),
      'сброс':        () => $('btn-reset')?.click(),
      'отменить':     () => { if (window.MikhmelViewer?.undoAnnotation) window.MikhmelViewer.undoAnnotation(); },
      'повторить':    () => { if (window.MikhmelViewer?.redoAnnotation) window.MikhmelViewer.redoAnnotation(); },
      // ── Навигация по срезам ──
      'следующий':    () => scrollSlice(1),
      'дальше':       () => scrollSlice(1),
      'вперёд':       () => scrollSlice(1),
      'предыдущий':   () => scrollSlice(-1),
      'назад':        () => scrollSlice(-1),
      'начало':       () => jumpToSlice(0),
      'конец':        () => jumpToSlice(-1),
      'середина':     () => jumpToSlice('mid'),
      // ── Срез по номеру (парсится отдельно) ──
      // ── Инструменты ──
      'зум':          () => activateTool('Zoom'),
      'масштаб':      () => activateTool('Zoom'),
      'увеличить':    () => zoomBy(1.3),
      'уменьшить':    () => zoomBy(0.7),
      'линейка':      () => activateTool('Length'),
      'длина':        () => activateTool('Length'),
      'угол':         () => activateTool('Angle'),
      'листание':     () => activateTool('StackScroll'),
      'прокрутка':    () => activateTool('StackScroll'),
      'двигать':      () => activateTool('Pan'),
      'вращение':     () => activateTool('TrackballRotate'),
      'вращать':      () => activateTool('TrackballRotate'),
      'лупа':         () => activateTool('Magnify'),
      'крест':        () => activateTool('Crosshairs'),
      'кисть':        () => activateTool('Brush'),
      'стрелка':      () => activateTool('ArrowAnnotate'),
      'текст':        () => activateTool('TextAnnotation'),
      'контраст':     () => activateTool('WindowLevel'),
      'яркость':      () => activateTool('WindowLevel'),
      // ── W/L пресеты ──
      'лёгочное окно':() => applyWLPreset(1500, -500),
      'костное окно': () => applyWLPreset(1500, 400),
      'мягкие ткани': () => applyWLPreset(400, 40),
      'мозговое окно':() => applyWLPreset(80, 40),
      'абдоминальное':() => applyWLPreset(400, 40),
      'печёночное':   () => applyWLPreset(150, 70),
      // ── Стоп ──
      'стоп': () => {
        _voiceRecognition?.stop();
        _voiceRecognition = null;
        btn?.classList.remove('active');
        showToast('🎤 Стоп', 'info', 800);
      }
    };

    // Вспомогательные функции для голосовых команд
    function scrollSlice(dir) {
      try {
        const re = getRenderingEngine();
        const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        if (!vp) return;
        const idx = vp.getCurrentImageIdIndex?.() || 0;
        const total = vp.getImageIds?.()?.length || 0;
        const newIdx = Math.max(0, Math.min(total - 1, idx + dir));
        vp.setImageIdIndex?.(newIdx);
        vp.render();
        showToast(`📜 Срез ${newIdx + 1}/${total}`, 'info', 600);
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
    }

    function jumpToSlice(target) {
      try {
        const re = getRenderingEngine();
        const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        if (!vp) return;
        const total = vp.getImageIds?.()?.length || 0;
        let idx = 0;
        if (target === -1) idx = total - 1;
        else if (target === 'mid') idx = Math.floor(total / 2);
        else idx = Math.max(0, Math.min(total - 1, target));
        vp.setImageIdIndex?.(idx);
        vp.render();
        showToast(`📜 Срез ${idx + 1}/${total}`, 'info', 600);
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
    }

    function activateTool(toolName) {
      setActiveTool(toolName);
      $$('.tool-btn').forEach(b => b.classList.toggle('active', b.dataset.tool === toolName));
      if (window.showToolIndicator) window.showToolIndicator(toolName);
      showToast(`🔧 ${toolName}`, 'info', 600);
    }

    function zoomBy(factor) {
      try {
        const re = getRenderingEngine();
        const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        if (!vp) return;
        const cam = vp.getCamera();
        if (cam.parallelProjection) {
          vp.setCamera({ parallelScale: cam.parallelScale / factor });
        }
        vp.render();
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
    }

    function applyWLPreset(ww, wc) {
      try {
        const re = getRenderingEngine();
        const vp = re?.getViewport(_ctx.getCurrentViewportId() || getViewportIds()[0]);
        if (vp) {
          vp.setProperties({ voiRange: { lower: wc - ww / 2, upper: wc + ww / 2 } });
          vp.render();
          updateWLOverlay(ww, wc);
          showToast(`🌓 W:${ww} / L:${wc}`, 'info', 800);
        }
      } catch (e) { log.debug('[FeatureBindings]', e.message); }
    }

    _voiceRecognition.onresult = (event) => {
      const text = event.results[event.results.length - 1][0].transcript.toLowerCase().trim();
      showToast(`🎤 «${text}»`, 'info', 2000);

      // Парсинг номера среза: "срез 50", "срез номер 120", "покажи 42"
      const sliceMatch = text.match(/(?:срез|слайс|покажи)\s*(?:номер\s*)?(\d+)/);
      if (sliceMatch) {
        const num = parseInt(sliceMatch[1]) - 1; // в 0-based
        jumpToSlice(num);
        return;
      }

      // Парсинг "десять вперёд", "двадцать назад"
      const skipMatch = text.match(/(\d+)\s*(вперёд|дальше|назад)/);
      if (skipMatch) {
        const n = parseInt(skipMatch[1]);
        const dir = skipMatch[2] === 'назад' ? -n : n;
        scrollSlice(dir);
        return;
      }

      // Стандартные команды
      Object.entries(commands).forEach(([key, fn]) => { if (text.includes(key)) fn(); });
    };

    _voiceRecognition.onerror = (e) => {
      if (e.error === 'no-speech') return;
      log.warn('Voice error:', e.error);
      _voiceRecognition = null;
      btn?.classList.remove('active');
      showToast(`🎤 Ошибка: ${e.error}`, 'error');
    };

    _voiceRecognition.onend = () => {
      if (_voiceRecognition && btn?.classList.contains('active')) {
        try { _voiceRecognition.start(); } catch (e) { log.debug('[FeatureBindings]', e.message); }
      }
    };

    _voiceRecognition.start();
    btn?.classList.add('active');
    showToast('🎤 Голосовое управление (ru-RU)\n' +
      'Навигация: следующий, предыдущий, срез 50, начало, конец\n' +
      'Инструменты: линейка, зум, лупа, листание, вращать\n' +
      'Окно: лёгочное окно, костное окно, мягкие ткани\n' +
      'Пресеты: кости, лёгкие, сосуды, мозг, сердце\n' +
      'Действия: увеличить, уменьшить, инверсия, снимок, стоп', 'success', 5000);
  }

// ─── WebGPU CHECK ─────────────────────────────────────────────
function bindWebGPUCheck() {
  on('btn-webgpu-check', 'click', async () => {
    const btn = $('btn-webgpu-check');
    if (!btn) return;
    btn.textContent = '⏳ Проверка...';

    if (!navigator.gpu) {
      showToast('⚡ WebGPU ❌ Не поддерживается', 'error');
      btn.textContent = '❌ WebGPU';
      return;
    }
    try {
      const adapter = await navigator.gpu.requestAdapter();
      if (!adapter) {
        showToast('⚡ WebGPU ⚠️ Адаптер не найден', 'error');
        btn.textContent = '⚠️ No Adapter';
        return;
      }
      const device = await adapter.requestDevice();
      const info = adapter.info || {};
      const details = [
        '✅ WebGPU Поддерживается!',
        `Vendor: ${info.vendor || 'N/A'}`,
        `Architecture: ${info.architecture || 'N/A'}`,
        `Max buffer: ${(device.limits.maxBufferSize / 1024 / 1024).toFixed(0)} MB`,
        `Max workgroup: ${device.limits.maxComputeWorkgroupSizeX}`,
      ].join('\n');
      showToast(`⚡ ${details}`, 'success', 8000);
      btn.textContent = '✅ WebGPU';
      btn.style.borderColor = 'var(--success)';

      // Обновляем бейдж в statusbar
      const badge = $('webgpu-badge');
      if (badge) {
        badge.textContent = 'WebGPU ✓';
        badge.style.background = 'rgba(34,197,94,0.15)';
        badge.style.color = '#22c55e';
      }
      device.destroy();
    } catch (e) {
      showToast(`⚡ Ошибка WebGPU: ${e.message}`, 'error');
      btn.textContent = '❌ Error';
    }
  });
}


// ══════════════════════════════════════════════════════════════
// ENTERPRISE FEATURES (v6) — Real functionality
// ══════════════════════════════════════════════════════════════

/** @type {Map<string, boolean>} Feature flags — toggle groups on/off */
const _featureFlags = new Map();
/** @type {Map<string, number>} Feature usage counters */
const _featureUsage = new Map();
const _featureGroups = {
  'ai': ['btn-ai-calcium','btn-ai-cardiac','btn-ai-lung-nodules','btn-ai-lung-analysis','btn-ai-organs','btn-ai-brain','btn-ai-stroke','btn-ai-screening','btn-ai-sam','btn-ai-auto-contour','btn-ai-region-grow','btn-ai-export-stl','btn-ai-detect-body','btn-ai-release','btn-ai-lung-seg','btn-ai-rt-contour'], // [11.1.29] двум карточкам выданы id — раньше их не видели ни палитра, ни эта группа (аудит §2.2; в аудите ошибочно насчитал три — у «Инсульта» id был)
  'seg': ['btn-seg-undo','btn-seg-redo','btn-seg-clear'], // [11.1.21] «btn-seg-opacity» убран: кнопки с таким id никогда не было (ползунок зовётся seg-opacity) — счётчик бил в призрак
  '4d': ['btn-pro-4d-prev','btn-pro-4d-next','btn-pro-4d-play','btn-pro-4d-stop'],
  'sync': ['btn-pro-pos-sync','btn-pro-mpr-sync','btn-pro-smart-compare'],
  'session': ['btn-pro-session-start','btn-pro-session-stop','btn-pro-session-export'],
  'camera': ['btn-pro-cam-push','btn-pro-cam-pop'],
  'slab': ['btn-pro-slab-mip','btn-pro-slab-minip','btn-pro-slab-avg','btn-pro-slab-cycle'],
};

/**
 * Enable/disable a feature group (hides/shows related buttons)
 * @param {string} group — 'ai'|'seg'|'4d'|'sync'|'session'|'camera'|'slab'
 * @param {boolean} enabled
 */
export function setFeatureGroupEnabled(group, enabled) {
  const ids = _featureGroups[group];
  if (!ids) return;
  _featureFlags.set(group, enabled);
  for (const id of ids) {
    const el = document.getElementById(id);
    if (el) {
      el.style.display = enabled ? '' : 'none';
      el.disabled = !enabled;
    }
  }
  log.debug(`[Features] Group '${group}' ${enabled ? 'enabled' : 'disabled'} (${ids.length} buttons)`);
}

/**
 * Get all feature groups and their enabled state
 * @returns {Object}
 */
export function getFeatureGroups() {
  const result = {};
  for (const [group, ids] of Object.entries(_featureGroups)) {
    result[group] = {
      enabled: _featureFlags.get(group) !== false,
      buttonCount: ids.length,
      buttons: ids,
    };
  }
  return result;
}

/**
 * Track feature usage (call when a feature button is clicked)
 * @param {string} featureId
 */
export function trackFeatureUsage(featureId) {
  _featureUsage.set(featureId, (_featureUsage.get(featureId) || 0) + 1);
}

/**
 * Get feature usage analytics — top used features
 * @param {number} [topN=10]
 * @returns {Array<{feature:string, count:number}>}
 */
export function getFeatureUsageStats(topN = 10) {
  return [..._featureUsage.entries()]
    .sort((a, b) => b[1] - a[1])
    .slice(0, topN)
    .map(([feature, count]) => ({ feature, count }));
}

/**
 * Search features by name/description across all panel buttons
 * @param {string} query
 * @returns {Array<{id:string, text:string, group:string}>}
 */
export function searchFeatures(query) {
  const q = query.toLowerCase();
  const results = [];
  for (const [group, ids] of Object.entries(_featureGroups)) {
    for (const id of ids) {
      const el = document.getElementById(id);
      if (!el) continue;
      const text = el.textContent || el.title || id;
      if (text.toLowerCase().includes(q) || id.toLowerCase().includes(q)) {
        results.push({ id, text: text.trim(), group });
      }
    }
  }
  return results;
}

/**
 * Enable all feature groups
 */
export function enableAllFeatures() {
  for (const group of Object.keys(_featureGroups)) setFeatureGroupEnabled(group, true);
  showToast('✅ Все функции включены', 'success', 1200);
}

/**
 * Disable all feature groups (minimal mode)
 */
export function disableAllFeatures() {
  for (const group of Object.keys(_featureGroups)) setFeatureGroupEnabled(group, false);
  showToast('🔒 Все функции отключены (минимальный режим)', 'warning', 1500);
}

/**
 * Reset usage analytics
 */
export function resetFeatureUsage() {
  _featureUsage.clear();
  log.debug('[Features] Usage stats reset');
}
